// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:13:37.233Z
// Property: Pheasant Ridge (ID: 6767906449167237)
// Collections: 26 amenities, 9 floorplans (live), 23 photos, 65 POIs, 4 reviews, 3 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167237",
  "property_external_id": "1139493",
  "property_zillow_url": "https://www.zillow.com/apartments/watford-city-nd/pheasant-ridge/CkBGM4/",
  "property_apartments_url": "https://www.apartments.com/bakken-ridge-apartments-watford-city-nd/9vt7wm4/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "47759046523",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "pheasant-ridge",
  "property_name": "Pheasant Ridge",
  "property_website_url": "https://www.homeispheasantridge.com",
  "property_domain": "https://www.homeispheasantridge.com",
  "property_address": "209 11th Ave NE",
  "property_full_address": "209 11th Ave NE suite 113, Watford City, ND 58854",
  "property_address_1": "209 11th Ave NE",
  "property_address_2": "suite 113",
  "property_address_city": "Watford City",
  "property_address_state": "ND",
  "property_address_zip_full": null,
  "property_address_zip": "58854",
  "property_address_country": "US",
  "property_address_county": "McKenzie County",
  "property_neighborhood_address": "North Dakota Area",
  "property_address_latitude": "47.81236320000001",
  "property_address_longitude": "-103.281365",
  "property_email": "pheasantridge@weidner.com",
  "property_phone": "7014078060",
  "property_call_tracking_phone": "701-712-5709",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Comfortable Watford City living starts at Pheasant Ridge.</strong> Choose an open one-, two-, or three-bedroom apartment with everyday essentials like in-home laundry and central air, then schedule a tour to see how easily comfort comes home.</p>",
  "property_long_description": "<p><strong>Comfortable Watford City living starts at Pheasant Ridge.</strong> Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with open living space, central air and heat, in-home washer and dryer, walk-in closets, and well-equipped kitchens with a dishwasher, microwave, range, refrigerator, and garbage disposal. Select homes add a kitchen island or vaulted ceilings, while a private patio or balcony extends your space outdoors.</p><p>Here, everyday convenience comes built in, from open parking and available single garages to 24-hour emergency maintenance, online payments, friendly professional management, and a smoke-free, <a href=\"/pet-policy\">pet-welcoming</a> community. Your Watford City address also keeps you close to Main Street dining and coffee spots like Door 204, Outlaws’ Bar &amp; Grill, and Stonehome Brewing, plus Rough Rider Center events, Six Shooters Showhall, Fox Hills Golf Course, Wild West Water Park, and the wide-open scenery of Theodore Roosevelt National Park’s North Unit. Explore more on the <a href=\"/neighborhood\">neighborhood</a> page, then come see how Pheasant Ridge brings comfort home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-54e0-7333-9c94-dec70684e563.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building with balconies and green lawn.",
    "public_id": "019d0227-54e0-7333-9c94-dec70684e563",
    "storage_key": "property/6767906449167237/019d0227-54e0-7333-9c94-dec70684e563.webp",
    "width": 800,
    "height": 449
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "42",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": "19",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.47619047619048",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: Varies",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://homeispheasantridge.securecafe.com/onlineleasing/pheasant-ridge-4/floorplans.aspx",
  "property_resident_portal_url": "https://homeispheasantridge.securecafenet.com/residentservices/pheasant-ridge-4/userlogin",
  "property_apply_now_url": "https://homeispheasantridge.securecafe.com/onlineleasing/pheasant-ridge-4/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03fbf-464c-75ae-b50d-290880f96234.webp",
  "property_primary_logo_media": {
    "alt_text": "Pheasant Ridge Apartments logo",
    "public_id": "01a03fbf-464c-75ae-b50d-290880f96234",
    "storage_key": "property/6767906449167237/01a03fbf-464c-75ae-b50d-290880f96234.webp",
    "width": 123,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03fbf-823e-72a9-b744-7aa2f01e7134.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03fbf-823e-72a9-b744-7aa2f01e7134",
    "storage_key": "property/6767906449167237/01a03fbf-823e-72a9-b744-7aa2f01e7134.webp",
    "width": 123,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03fbf-7784-74cb-af74-b1b430403ca5.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03fbf-7784-74cb-af74-b1b430403ca5",
    "storage_key": "property/6767906449167237/01a03fbf-7784-74cb-af74-b1b430403ca5.webp",
    "width": 123,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#ad7d73",
  "property_secondary_color": "#b78d63",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#534343",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1345",
  "property_sqft_min": "725",
  "property_sqft_max": "1345",
  "property_price_range": "21.4 - 1785",
  "property_price_min": "21.4",
  "property_price_max": "1785",
  "property_available_units": 30,
  "property_facebook_url": "https://www.facebook.com/PheasantRidgeApartmentHomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJf-LlGBG3JlMRe_oT8b0Amn0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pheasant Ridge",
  "property_home_romance_title": "Experience Love at First Sight with Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, streamlined.</strong> Pheasant Ridge pairs open, easy-living layouts with central air and heat, in-home laundry, walk-in closets, and a private patio or balcony. Kitchens come ready with a dishwasher, microwave, range, refrigerator, and disposal, while plank flooring and thoughtful finishes add a polished touch.</p><p>Open parking, available single garages, online resident services, and 24-hour emergency maintenance help keep life in Watford City simple.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout that fits your day.</strong> Choose from one-, two-, and three-bedroom apartments in Watford City with open living areas, in-home washer and dryer, central air and heat, walk-in closets, and a private patio or balcony. Select homes add a kitchen island or vaulted ceilings for even more breathing room.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Pheasant Ridge.</strong> Browse photos of open living rooms with plank flooring, bright kitchens with full appliance packages, select islands, private patios or balconies, walk-in closets, and in-home laundry. Then compare one-, two-, and three-bedroom layouts, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see more in Watford City.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Everyday access meets Western North Dakota adventure.</strong> Pheasant Ridge keeps you close to Watford City favorites, from North Main Street dining and local shops to The Merc at Long X, McKenzie County Heritage Park, and Rough Rider Center events. When the horizon calls, the Badlands, Little Missouri River, Maah Daah Hey Trail, and Theodore Roosevelt National Park’s North Unit are all within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to love at Pheasant Ridge.</strong> Reviews highlight spacious layouts with large living areas and kitchens made for cooking and entertaining, plus well-kept homes and fast maintenance response. Many also praise the leasing team—especially Salli/Sally/Sallie—for clear communication, genuine care, and an easy move-in experience. Read the full reviews to see why Pheasant Ridge earns such strong recommendations.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map to everyday access and Western North Dakota adventure.</strong> From Pheasant Ridge, you can keep daily routines close to home while staying connected to the energy of Watford City—North Main Street dining, local shops, and community events are just a short drive away.</p><p>Spend an easy afternoon browsing The Merc at Long X, exploring local history at McKenzie County Heritage Park, or heading to the Rough Rider Center for recreation and events. When you want wider horizons, the Badlands, Little Missouri River, Maah Daah Hey Trail, and Theodore Roosevelt National Park’s North Unit put some of the region’s most memorable scenery within reach. Start with the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Pheasant Ridge connects home, town, and the outdoors.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that simplify your everyday rhythm.</strong> At Pheasant Ridge, your apartment is set up for comfort from the moment you walk in, with central air and heat, in-home washer and dryer, generous walk-in closet space, and a private patio or balcony that gives you a little room to breathe.</p><p>Inside, open layouts connect your living area to a well-equipped kitchen with a dishwasher, microwave, range, refrigerator, and garbage disposal, while plank flooring, window coverings, and select kitchen islands or vaulted ceilings add a polished feel. Beyond your door, open parking, available single garages, online resident services, and 24-hour emergency maintenance keep life in Watford City practical and convenient. Explore the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Pheasant Ridge home?</strong> Start your online application for comfortable Watford City apartments with open one-, two-, and three-bedroom layouts, in-home laundry, central air and heat, and everyday conveniences like online payments and professional management.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Pheasant Ridge leasing team to learn more about our one-, two-, and three-bedroom apartments, community conveniences, availability, or directions to 209 11th Ave NE suite 113 in Watford City. We’d be happy to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Pheasant Ridge?</strong> Find quick answers about the community, leasing, apartment features, pet-welcoming living, maintenance, and everyday convenience in Watford City. If you need anything else, the friendly professional leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the layout that works the way you do.</strong> Pheasant Ridge offers one-, two-, and three-bedroom apartments in Watford City, with options ranging from efficient one-bedroom homes to larger two- and three-bedroom layouts with two baths. Open living areas give you room to settle in, while in-home washer and dryer, central air and heat, walk-in closets, and a private patio or balcony add everyday ease. Select apartments include a kitchen island or vaulted ceilings for an extra sense of space. Browse current floor plan cards to compare layouts, pricing, and availability, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see which home feels right.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you step inside.</strong> The Pheasant Ridge photo gallery brings each space into focus, from open living rooms with plank flooring and soft natural light to kitchens framed by clean cabinetry, full appliance packages, and select islands made for easy prep. As you browse, notice how private patios and balconies extend the view, how walk-in closets and in-home laundry fit neatly into daily routines, and how the exterior setting includes open parking with single garages available.</p><p>Use these photos to compare the feel of one-, two-, and three-bedroom layouts, then explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Pheasant Ridge in Watford City up close.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Pheasant Ridge on the map.</strong> See available apartments in Watford City and get a feel for the neighborhood, from Main Street dining and coffee to nearby recreation, events, and wide-open outdoor scenery.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, routines, and easy days.</strong> At Pheasant Ridge, cats and dogs can feel at home alongside the comforts you count on, from open living areas to in-home washer and dryer for quick cleanup after muddy walks. A private patio or balcony gives you fresh-air space, while plank flooring and walk-in closets help keep daily pet gear organized.</p><p>When it’s time to stretch four legs, nearby Doc Nelson Dog Park offers off-leash space with separate areas and agility features, and local veterinary care is close by for everyday needs. Review the pet policy details on this page, then explore our <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to find a pet-friendly apartment in Watford City that fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Pheasant Ridge.</strong> If open layouts, in-home laundry, private outdoor space, pet-welcoming living, and friendly professional management make life easier here, invite a friend to experience it too. Use the referral form to help them find their next Watford City apartment.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access makes everyday convenience simple.</strong><br>Log in to pay rent online, submit maintenance requests, and manage your Pheasant Ridge account with ease—supported by friendly professional management and 24-hour emergency maintenance when you need it.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Pheasant Ridge.</strong> As you read the reviews, you’ll notice a clear theme: spacious apartments, responsive service, and a leasing team that makes the experience feel easy.</p><p>Residents praise layouts with large living areas and kitchens—“so much room to cook &amp; entertain”—along with well-kept homes and maintenance requests handled very quickly. Many also call out Salli/Sally/Sallie for helpful communication, genuine care, and making move-in details clear. If you’re looking for real feedback from people who have lived here, these reviews offer an honest look at what makes Pheasant Ridge a place residents are happy to recommend.</p>",
  "property_created_at": "1771542908942",
  "property_scheduletour_blurb": "<p><strong>See comfort up close at Pheasant Ridge.</strong> Tour open one-, two-, and three-bedroom layouts with in-home laundry, walk-in closets, well-equipped kitchens, and outdoor space in select homes. Schedule your visit today and picture everyday living in Watford City.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Pheasant Ridge.</strong><br>Your inquiry has been received, and our leasing team will follow up soon. In the meantime, picture comfortable Watford City living with open one-, two-, and three-bedroom layouts, in-home laundry, and everyday convenience built in.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the flow before you visit.</strong> Step inside Pheasant Ridge from wherever you are with virtual tours of the 1x1 B, 2x2 A, and 3x2 B apartment layouts. Move room to room at your own pace, compare how each floor plan opens into the living area, and picture everyday details like in-home laundry, well-equipped kitchens, walk-in closet space, and a patio or balcony.</p><p>Whether you are narrowing down a one-bedroom, exploring the balance of a two-bedroom, or looking for the added room of a three-bedroom apartment in Watford City, these walkthroughs help you see what photos alone cannot. After your tour, compare <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2026 All Rights Reserved. Pheasant Ridge",
  "property_seo_title_home": "Pheasant Ridge |  Apartments in Watford City, ND",
  "property_seo_description_home": "Discover comfort at Pheasant Ridge in Watford City! Choose from stylish one to three-bedroom apartments with modern amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Watford City, ND Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Pheasant Ridge in Watford City, ND! Browse unique one, two, and three-bedroom floor plans designed for your perfect fit.",
  "property_seo_title_amenities": "Amenities | Watford City, ND Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and style at Pheasant Ridge in Watford City! Enjoy modern amenities like spacious floor plans, open parking, and pet-friendly living.",
  "property_seo_title_gallery": "Gallery | Apartments in Watford City, ND",
  "property_seo_description_gallery": "Discover life at Pheasant Ridge, Watford City! Spacious, modern apartments, 24/7 maintenance, and pet-friendly living await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Pheasant Ridge Apartments",
  "property_seo_description_virtualtours": "Discover Pheasant Ridge in Watford City, ND! Explore stunning one to three-bedroom homes. Take a virtual tour and find your perfect fit!",
  "property_seo_title_interactivemap": "Interactive Map | Pheasant Ridge Apartments",
  "property_seo_description_interactivemap": "Experience comfort at Pheasant Ridge in Watford City, ND. Our spacious one to three-bedroom apartments feature modern amenities & a welcoming community.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Watford City, ND",
  "property_seo_description_neighborhood": "Uncover the charm of Watford City living at Pheasant Ridge! Dive into the vibrant neighborhood, local favorites, and explore nearby attractions today!",
  "property_seo_title_contact": "Contact Us | Pheasant Ridge",
  "property_seo_description_contact": "Connect with Pheasant Ridge in Watford City, ND! From cozy one-bedrooms to spacious three-bedrooms, we're here to help. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Watford City, ND",
  "property_seo_description_faqs": "Find answers to your questions about Pheasant Ridge in Watford City, ND. Discover our amenities and learn how life is enhanced in our welcoming community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Watford City, ND",
  "property_seo_description_reviews": "Join the welcoming community at Pheasant Ridge in Watford City, featuring modern amenities, spacious layouts, and pet-friendly living!",
  "property_seo_title_applynow": "Apply Now | Apartments in Watford City, ND",
  "property_seo_description_applynow": "Live comfortably at Pheasant Ridge in Watford City! Enjoy modern amenities, spacious floor plans, and a welcoming community. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Pheasant Ridge",
  "property_seo_description_residentaccess": "Manage your Pheasant Ridge home easily through the resident portal for rent, maintenance requests, and community needs in Watford City.",
  "property_seo_title_referafriend": "Refer A Friend | Pheasant Ridge",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Pheasant Ridge in Watford City, ND, and enjoy a vibrant community living experience together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Pheasant Ridge",
  "property_seo_description_scheduletour": "Experience modern living at Pheasant Ridge in Watford City, ND! Book your tour today and envision your new home in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Pheasant Ridge",
  "property_seo_description_privacy": "At Pheasant Ridge, your privacy matters. Discover how we protect your information for a secure living experience. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Pheasant Ridge",
  "property_seo_description_accessibility": "At Pheasant Ridge in Watford City, ND, we prioritize digital inclusion. Join our community and experience accessible living designed for everyone's comfort.",
  "property_seo_title_sitemap": "Sitemap | Pheasant Ridge",
  "property_seo_description_sitemap": "Uncover a world of possibilities at Pheasant Ridge, Watford City’s premier apartment community. Navigate our sitemap and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Pheasant Ridge",
  "property_seo_description_thankyou": "Thank you for reaching out to Pheasant Ridge! Our team is excited to connect and help you find your perfect home in Watford City. Stay tuned for our response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Watford City, ND",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791389295748",
  "amenities": [
    {
      "id": "ec_a5c586e7bb18a2ea2d143e92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646623",
      "title": "24 - Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e36d28252baa155148886769",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646625",
      "title": "Open Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-77cc-73cc-b44a-5529490cef3f.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with balconies and parking lot.",
        "public_id": "019d0227-77cc-73cc-b44a-5529490cef3f",
        "storage_key": "property/6767906449167237/019d0227-77cc-73cc-b44a-5529490cef3f.webp",
        "width": 1110,
        "height": 623
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_beb7f912aa4c84ac3e0ed342",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646626",
      "title": "Professionally Managed",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f5d3f73b7737c8b8a1cdd6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646628",
      "title": "Online Electronic Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69d76088f79fe3cc7442e3ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646629",
      "title": "Single Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d73c-aff2-739e-89b4-6a5bef854fd4.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a long row of garages with white doors and gray siding under a blue sky.",
        "public_id": "01a0d73c-aff2-739e-89b4-6a5bef854fd4",
        "storage_key": "property/6767906449167237/01a0d73c-aff2-739e-89b4-6a5bef854fd4.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Garage",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b82acde606035769d255eeba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646630",
      "title": "Friendly Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f50d0c63f0bf3240a39dcace",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646631",
      "title": "Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa9ecb307098112c427bd109",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "124800180",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09e2a3cc0fec5cd6fee2cd5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646632",
      "title": "Pets Welcome",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d953a41ad1ff6f73aa96459",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646633",
      "title": "Central Air & Heat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_164d00ee799089c91b2de70e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646634",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_968d3410db6538f26823a39b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646637",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb3916bbbdd81943271833f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646639",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1eddebd9d240a34fa96f0c9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646640",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d73c-b07b-746f-9786-6d9ff9fb8b3a.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with sliding glass door and railing overlooking trees and distant buildings",
        "public_id": "01a0d73c-b07b-746f-9786-6d9ff9fb8b3a",
        "storage_key": "property/6767906449167237/01a0d73c-b07b-746f-9786-6d9ff9fb8b3a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Balcony",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a681338a5554ad6676dbd071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646641",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c8c653b8b368e64cb397ba8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646646",
      "title": "Cable Ready & Internet Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71964f85ab0cff33512e55cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646648",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_934c0e3b38607096a6fa6adf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646651",
      "title": "Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d9a3c-7ccb-71ff-a48e-d317fc496893.webp",
      "amenity_image_media": {
        "alt_text": "In-unit laundry room with washer and dryer",
        "public_id": "019d9a3c-7ccb-71ff-a48e-d317fc496893",
        "storage_key": "property/6767906449167237/019d9a3c-7ccb-71ff-a48e-d317fc496893.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35fcfebe4c2e6224bb028c4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646636",
      "title": "Open Floor Plan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-7785-7762-8248-3135fe91d36a.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living area and kitchen with bar seating and sliding glass doors.",
        "public_id": "019d0227-7785-7762-8248-3135fe91d36a",
        "storage_key": "property/6767906449167237/019d0227-7785-7762-8248-3135fe91d36a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Open Concept",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7036f4d304e0e3f3d6d9009",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646638",
      "title": "Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b65dcedd6e57eb579ef323c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646642",
      "title": "Kitchen Island in Select Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-7785-7762-8248-2c15b582cb30.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, a black refrigerator, oven, and microwave, and a central island.",
        "public_id": "019d0227-7785-7762-8248-2c15b582cb30",
        "storage_key": "property/6767906449167237/019d0227-7785-7762-8248-2c15b582cb30.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Kitchen Island",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75423778a1829489223530e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646643",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-813b-7428-80c8-3f55f55e93a4.webp",
      "amenity_image_media": {
        "alt_text": "Ground floor patio with sliding glass door and air conditioning unit on exterior wall of apartment building.",
        "public_id": "019d0227-813b-7428-80c8-3f55f55e93a4",
        "storage_key": "property/6767906449167237/019d0227-813b-7428-80c8-3f55f55e93a4.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Patio",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f606a1894b2d245c123f509b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646645",
      "title": "Walk-In-Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-8142-7242-aba8-7bc4b4f362f5.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with shelving next to a bathroom",
        "public_id": "019d0227-8142-7242-aba8-7bc4b4f362f5",
        "storage_key": "property/6767906449167237/019d0227-8142-7242-aba8-7bc4b4f362f5.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Walk In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9a8fed9b1993f8de27b5965",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646647",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_363e5001f12c26179eac1498",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646649",
      "title": "Range with Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-8234-748b-b492-1c50a025f7d0.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with black appliances, wood cabinets, and a double sink.",
        "public_id": "019d0227-8234-748b-b492-1c50a025f7d0",
        "storage_key": "property/6767906449167237/019d0227-8234-748b-b492-1c50a025f7d0.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Pheasant Ridge Oven Range",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40484dbeae30ffdfe70c31ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "external_id": "87646650",
      "title": "Vaulted Ceilings in Select Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1bc79da9a70cb3d3d41332d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-54e0-7333-9c94-dec70684e563.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and green lawn.",
        "public_id": "019d0227-54e0-7333-9c94-dec70684e563",
        "storage_key": "property/6767906449167237/019d0227-54e0-7333-9c94-dec70684e563.webp",
        "width": 800,
        "height": 449
      },
      "title": "Community",
      "description": "Modern apartment building exterior with multiple levels of balconies and a well-maintained green lawn in front.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balconies and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (10).jpg"
    },
    {
      "id": "ec_4799c4231b3725e78d5e9143",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a08a01-27d3-7182-b1f6-a71508a14383.webp",
      "image_media": {
        "alt_text": "Get up to $1,000 off first month rent offer",
        "public_id": "01a08a01-27d3-7182-b1f6-a71508a14383",
        "storage_key": "property/6767906449167237/01a08a01-27d3-7182-b1f6-a71508a14383.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Limited time offer: Get up to $1,000 off your first month rent. Offer expires 9/25/2026. Restrictions apply.",
      "link": "false",
      "alt_text": "Get up to $1,000 off first month rent offer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Copy of Copy of Move In Specials (12).png"
    },
    {
      "id": "ec_b3a69700e7c78b195beac4e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22c-e4ba-77cf-8939-ffc21bad1e69.webp",
      "image_media": {
        "alt_text": "Ground-level patio with sliding glass door and air conditioning unit.",
        "public_id": "01a0d22c-e4ba-77cf-8939-ffc21bad1e69",
        "storage_key": "property/6767906449167237/01a0d22c-e4ba-77cf-8939-ffc21bad1e69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your private patio space with easy access to your apartment. Perfect for outdoor relaxation.",
      "link": "false",
      "alt_text": "Ground-level patio with sliding glass door and air conditioning unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (29).jpg"
    },
    {
      "id": "ec_729e03158a723bb6f8497873",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22c-fd01-7188-9ce5-6fa262f21791.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and a parking lot.",
        "public_id": "01a0d22c-fd01-7188-9ce5-6fa262f21791",
        "storage_key": "property/6767906449167237/01a0d22c-fd01-7188-9ce5-6fa262f21791.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern living with our apartment building's exterior, featuring private balconies and ample parking.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balconies and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (28).jpg"
    },
    {
      "id": "ec_89acf322e6743912d66533a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22c-e45e-72bf-b6df-3b5e3525aa0c.webp",
      "image_media": {
        "alt_text": "Row of attached garage doors with numbers visible, set against a bright blue sky with scattered clouds.",
        "public_id": "01a0d22c-e45e-72bf-b6df-3b5e3525aa0c",
        "storage_key": "property/6767906449167237/01a0d22c-e45e-72bf-b6df-3b5e3525aa0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient and secure attached garage parking available for residents, offering protection from the elements and ample storage space.",
      "link": "false",
      "alt_text": "Row of attached garage doors with numbers visible, set against a bright blue sky with scattered clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (27).jpg"
    },
    {
      "id": "ec_aea593a72bc5f8bb87c8c83e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22c-e449-75a8-a27b-08ef1a325a6f.webp",
      "image_media": {
        "alt_text": "Balcony overlooking apartment complex on a sunny day",
        "public_id": "01a0d22c-e449-75a8-a27b-08ef1a325a6f",
        "storage_key": "property/6767906449167237/01a0d22c-e449-75a8-a27b-08ef1a325a6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy private outdoor space on your apartment's balcony, perfect for relaxing or taking in the views.",
      "link": "false",
      "alt_text": "Balcony overlooking apartment complex on a sunny day",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (26).jpg"
    },
    {
      "id": "ec_b2d429235bd1272b89bbb8c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22c-e451-752a-9c28-a2cc02327979.webp",
      "image_media": {
        "alt_text": "Empty room with beige walls, carpet, and a window with blinds.",
        "public_id": "01a0d22c-e451-752a-9c28-a2cc02327979",
        "storage_key": "property/6767906449167237/01a0d22c-e451-752a-9c28-a2cc02327979.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and carpeted empty room with a large window, ready for you to make it your own.",
      "link": "false",
      "alt_text": "Empty room with beige walls, carpet, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Pheasant Ridge_20.jpg"
    },
    {
      "id": "ec_bb00e0be44f5a851f73f8531",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-1ee1-7609-9275-8d9522dd524a.webp",
      "image_media": {
        "alt_text": "White shower and bathtub combo with chrome fixtures.",
        "public_id": "01a0d22d-1ee1-7609-9275-8d9522dd524a",
        "storage_key": "property/6767906449167237/01a0d22d-1ee1-7609-9275-8d9522dd524a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and modern white shower and bathtub combination featuring chrome fixtures, a shower head, and a drain. Located next to a wooden door and a brown cabinet.",
      "link": "false",
      "alt_text": "White shower and bathtub combo with chrome fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (25).jpg"
    },
    {
      "id": "ec_942065c95b714d3319c09989",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-239d-71f9-b8b9-2b797c72ea92.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet and sliding glass doors.",
        "public_id": "01a0d22d-239d-71f9-b8b9-2b797c72ea92",
        "storage_key": "property/6767906449167237/01a0d22d-239d-71f9-b8b9-2b797c72ea92.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This expansive living area features plush carpeting and large sliding glass doors, offering ample natural light and access to outdoor spaces.",
      "link": "false",
      "alt_text": "Spacious living room with carpet and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (24).jpg"
    },
    {
      "id": "ec_d2bffb499c14e22b16d3db89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-245c-74ec-8f21-b2ea58ce092c.webp",
      "image_media": {
        "alt_text": "Empty living room and kitchen area with island and closet.",
        "public_id": "01a0d22d-245c-74ec-8f21-b2ea58ce092c",
        "storage_key": "property/6767906449167237/01a0d22d-245c-74ec-8f21-b2ea58ce092c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a modern kitchen island, ample closet space, and a bright, open layout.",
      "link": "false",
      "alt_text": "Empty living room and kitchen area with island and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (23).jpg"
    },
    {
      "id": "ec_69f65f44ce5614e4af355f5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-2650-702b-8010-bad163038fd7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in apartment.",
        "public_id": "01a0d22d-2650-702b-8010-bad163038fd7",
        "storage_key": "property/6767906449167237/01a0d22d-2650-702b-8010-bad163038fd7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpet opens to a modern kitchen with a large island and ample cabinet space.",
      "link": "false",
      "alt_text": "Living room and kitchen area in apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (22).jpg"
    },
    {
      "id": "ec_861303bd7d83aa103bba75e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-3847-774a-905a-933e8260f247.webp",
      "image_media": {
        "alt_text": "Kitchen island with double sink, dishwasher, and ample cabinet space.",
        "public_id": "01a0d22d-3847-774a-905a-933e8260f247",
        "storage_key": "property/6767906449167237/01a0d22d-3847-774a-905a-933e8260f247.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a large island with a double sink, dishwasher, and plenty of storage. Opens to a spacious living area.",
      "link": "false",
      "alt_text": "Kitchen island with double sink, dishwasher, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (21).jpg"
    },
    {
      "id": "ec_04491b269a4faf9d07a4739e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-4f6a-768a-9c53-348664d8cc2a.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, black appliances, and a large island sink.",
        "public_id": "01a0d22d-4f6a-768a-9c53-348664d8cc2a",
        "storage_key": "property/6767906449167237/01a0d22d-4f6a-768a-9c53-348664d8cc2a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinets, black appliances including a refrigerator, microwave, and oven, and a double-basin sink on a speckled countertop. The space opens to a living area with a sliding glass door.",
      "link": "false",
      "alt_text": "Kitchen with dark cabinets, black appliances, and a large island sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (20).jpg"
    },
    {
      "id": "ec_bfc0b942f43f7a8bd188faf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-6274-72f9-a5ae-ecd454fba8a6.webp",
      "image_media": {
        "alt_text": "Empty living room with large closet space and sliding glass doors to a balcony.",
        "public_id": "01a0d22d-6274-72f9-a5ae-ecd454fba8a6",
        "storage_key": "property/6767906449167237/01a0d22d-6274-72f9-a5ae-ecd454fba8a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring ample closet storage and natural light from sliding glass doors. Perfect for creating your ideal living space.",
      "link": "false",
      "alt_text": "Empty living room with large closet space and sliding glass doors to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (19).jpg"
    },
    {
      "id": "ec_811aa9c721c9573cfd7da4b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-60e7-7434-9a13-12ef3846b819.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, bathtub, and vanity with sink.",
        "public_id": "01a0d22d-60e7-7434-9a13-12ef3846b819",
        "storage_key": "property/6767906449167237/01a0d22d-60e7-7434-9a13-12ef3846b819.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, bathtub with shower, and a vanity with a sink and mirror.",
      "link": "false",
      "alt_text": "Bathroom with toilet, bathtub, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (18).jpg"
    },
    {
      "id": "ec_fe0b345466b8df42bf5f8626",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-6a5b-716a-9eed-da5f5fe6e9af.webp",
      "image_media": {
        "alt_text": "A clean bathroom with a toilet, sink, and bathtub/shower combo.",
        "public_id": "01a0d22d-6a5b-716a-9eed-da5f5fe6e9af",
        "storage_key": "property/6767906449167237/01a0d22d-6a5b-716a-9eed-da5f5fe6e9af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a functional toilet, a stylish vanity with a sink, and a pristine bathtub and shower combination, ready for use.",
      "link": "false",
      "alt_text": "A clean bathroom with a toilet, sink, and bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (17).jpg"
    },
    {
      "id": "ec_0771afc30979cc0b8af3ab5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-6a54-70c2-9de1-0d16c393046a.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry room with shelf",
        "public_id": "01a0d22d-6a54-70c2-9de1-0d16c393046a",
        "storage_key": "property/6767906449167237/01a0d22d-6a54-70c2-9de1-0d16c393046a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious laundry room featuring a washer and dryer, perfect for your convenience. Includes a convenient shelf for storage.",
      "link": "false",
      "alt_text": "Washer and dryer in laundry room with shelf",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (16).jpg"
    },
    {
      "id": "ec_7e6f7efaae47e37535bfe875",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-8f0c-713a-83ff-b50bf4cb29ae.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and light fixture",
        "public_id": "01a0d22d-8f0c-713a-83ff-b50bf4cb29ae",
        "storage_key": "property/6767906449167237/01a0d22d-8f0c-713a-83ff-b50bf4cb29ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral carpet, a large closet with hanging rod, and a ceiling light fixture. An adjacent bathroom is visible through the doorway.",
      "link": "false",
      "alt_text": "Bedroom with closet and light fixture",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (15).jpg"
    },
    {
      "id": "ec_c147f912c0d59613c9cfc13e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-9995-70aa-8c90-65e4e4540043.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment",
        "public_id": "01a0d22d-9995-70aa-8c90-65e4e4540043",
        "storage_key": "property/6767906449167237/01a0d22d-9995-70aa-8c90-65e4e4540043.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room seamlessly transitions into a well-equipped kitchen with ample cabinet space and modern appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (14).jpg"
    },
    {
      "id": "ec_bf089733bd61ddfb8480b7da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-a0f5-777e-ad4b-786315f79c55.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances, and a kitchen island.",
        "public_id": "01a0d22d-a0f5-777e-ad4b-786315f79c55",
        "storage_key": "property/6767906449167237/01a0d22d-a0f5-777e-ad4b-786315f79c55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, black appliances including a refrigerator, microwave, and oven, and a central island with a laminate countertop.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, black appliances, and a kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Pheasant Ridge_31.jpg"
    },
    {
      "id": "ec_ecfa25baabdef8a009225df6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-99f9-724e-8c31-749af0d8badf.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen-size bed, nightstands, a dresser, and a window view of greenery.",
        "public_id": "01a0d22d-99f9-724e-8c31-749af0d8badf",
        "storage_key": "property/6767906449167237/01a0d22d-99f9-724e-8c31-749af0d8badf.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage, and a serene view from the window.",
      "link": "false",
      "alt_text": "Bright bedroom with a queen-size bed, nightstands, a dresser, and a window view of greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (13).jpg"
    },
    {
      "id": "ec_e2da90d00fffe709638e3840",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-af7c-7400-b740-e252df679572.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors leading to a balcony.",
        "public_id": "01a0d22d-af7c-7400-b740-e252df679572",
        "storage_key": "property/6767906449167237/01a0d22d-af7c-7400-b740-e252df679572.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring plush carpeting and a sliding glass door that opens to a private balcony, perfect for enjoying the outdoors.",
      "link": "false",
      "alt_text": "Living room with sliding glass doors leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (12).jpg"
    },
    {
      "id": "ec_f169e2333d1291250f1affd5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a0d22d-b482-73ca-8809-8a923aee3d85.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and a floor lamp.",
        "public_id": "01a0d22d-b482-73ca-8809-8a923aee3d85",
        "storage_key": "property/6767906449167237/01a0d22d-b482-73ca-8809-8a923aee3d85.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, modern coffee table, and elegant floor lamp. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, and a floor lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Pheasant_Ridge_Favorites (11).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_17da7928-9383-48eb-951a-874b2f049e22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Door 204 Coffee",
      "poi_type": "Restaurants",
      "poi_address": "204 Main St N, Watford City, ND 58854, USA",
      "poi_short_description": "Casual cafe known for its coffee, smoothies, and mail service, plus artwork for sale.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-13cc-7206-9fe5-7df87927d3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-13cc-7206-9fe5-7df87927d3b8",
        "storage_key": "property/6767906449167237/01a03ed0-13cc-7206-9fe5-7df87927d3b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12546222417655102577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "door-204-coffee",
      "poi_latitude": "47.8025075",
      "poi_longitude": "-103.2828767",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-842-6441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed24-71a9-83ab-3a0d5d4250eb",
        "storage_key": "property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-2tdMGy3JlMRcfxf7dAiHa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_c56752b4-4a4a-4191-add7-abf31087b83a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Meg-A-Latte | Coffee House (Watford City Location)",
      "poi_type": "Restaurants",
      "poi_address": "109 6th Ave SE, Watford City, ND 58854, USA",
      "poi_short_description": "Cozy coffee shop serving drinks and breakfast, including macarons shipped from New York.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1858-726a-abef-db25a21af6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1858-726a-abef-db25a21af6a5",
        "storage_key": "property/6767906449167237/01a03ed0-1858-726a-abef-db25a21af6a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://meg-a-latte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=968363112941715810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meg-a-latte--coffee-house-watford-city-location",
      "poi_latitude": "47.7955854",
      "poi_longitude": "-103.2794432",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-444-3505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed24-71a9-83ab-3a0d5d4250eb",
        "storage_key": "property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ2f6L6Fa3JlMRYoF74B5RcA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c0184f2d-c4ff-4634-ad1e-7e8264983946",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Caribou Coffee",
      "poi_type": "Restaurants",
      "poi_address": "113 6th Ave SE, Watford City, ND 58854, USA",
      "poi_short_description": "Coffeehouse chain serving signature drinks, mochas & lattes, plus coffee & breakfast.",
      "poi_long_description": "Coffeehouse chain serving signature drinks, mochas & lattes, plus coffee & breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-11dd-726e-aa21-6ea86146c078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-11dd-726e-aa21-6ea86146c078",
        "storage_key": "property/6767906449167237/01a03ed0-11dd-726e-aa21-6ea86146c078.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.cariboucoffee.com/us/nd/watford-city/113-6th-avenue-se",
      "poi_directions_map_url": "https://maps.google.com/?cid=6530025138321045128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caribou-coffee",
      "poi_latitude": "47.794273",
      "poi_longitude": "-103.279942",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-842-2519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed24-71a9-83ab-3a0d5d4250eb",
        "storage_key": "property/6767906449167237/019d0227-ed24-71a9-83ab-3a0d5d4250eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_Ts2Ini3JlMRiDb_B0RPn1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c4bf4494-42fd-4724-bce3-33fb075c5b6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Pizza Pie On The Fly",
      "poi_type": "Restaurants",
      "poi_address": "Main St, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-9cc9-76be-98d0-f942363654e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-9cc9-76be-98d0-f942363654e1",
        "storage_key": "property/6767906449167237/019d0227-9cc9-76be-98d0-f942363654e1.webp",
        "width": 999,
        "height": 1280
      },
      "poi_business_url": "http://ppotf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9864927646498359656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-pie-on-the-fly",
      "poi_latitude": "47.7912077",
      "poi_longitude": "-103.2835642",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-651-6732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Sw-xm63JlMRaAl3iG1D54g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d28a0e45-dd67-404c-9cd3-5b9926956bcc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Smiling Moose",
      "poi_type": "Restaurants",
      "poi_address": "1005 Main St Suite A, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-11f3-714e-b1f2-087a0bf7c249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-11f3-714e-b1f2-087a0bf7c249",
        "storage_key": "property/6767906449167237/01a03ed0-11f3-714e-b1f2-087a0bf7c249.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.smilingmoosedeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=610291681607651190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiling-moose",
      "poi_latitude": "47.7911964",
      "poi_longitude": "-103.2840027",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-444-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdtowWC3JlMRdo-ZCw0xeAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_0e90131f-d44e-4fc1-b931-face5ad2762f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "JL Beers",
      "poi_type": "Restaurants",
      "poi_address": "101 Main St S, Watford City, ND 58854, USA",
      "poi_short_description": "Relaxed hangout featuring burgers with creative topping combos & an assortment of craft beers.",
      "poi_long_description": "Relaxed hangout featuring burgers with creative topping combos & an assortment of craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-41d2-77c4-a88c-6dcaf5facdbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-41d2-77c4-a88c-6dcaf5facdbd",
        "storage_key": "property/6767906449167237/01a03ece-41d2-77c4-a88c-6dcaf5facdbd.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.jlbeers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2422498193737868992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jl-beers",
      "poi_latitude": "47.8014321",
      "poi_longitude": "-103.2833482",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-2015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xvqoW63JlMRwGbFskVxniE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_85ea4331-42cb-4439-bc38-2fd3c5bed361",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Stonehome Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "313 Fox Hills Pkwy N, Watford City, ND 58854, USA",
      "poi_short_description": "Casual venue for beer, pizza and pasta dishes, plus other eats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-35bb-75d8-822b-aabf4a881266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-35bb-75d8-822b-aabf4a881266",
        "storage_key": "property/6767906449167237/01a03ece-35bb-75d8-822b-aabf4a881266.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.stonehomebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3651499225316098131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stonehome-brewing-company",
      "poi_latitude": "47.8039442",
      "poi_longitude": "-103.2430017",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-444-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0sYBJO3JlMRU4CU7jK7rDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_c6a558dc-cdcd-4246-bcc9-84fc3922251d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Tokyo Japanese Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "105 9th Ave SE ste5, Watford City, ND 58854, USA",
      "poi_short_description": "Sushi, hibachi, and other Japanese dishes, including gluten-free and vegetarian options, served in an easygoing space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1104-76a1-adf6-03021d3a806b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1104-76a1-adf6-03021d3a806b",
        "storage_key": "property/6767906449167237/01a03ed0-1104-76a1-adf6-03021d3a806b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13226526751371116546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo-japanese-steakhouse",
      "poi_latitude": "47.791645",
      "poi_longitude": "-103.2823791",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-842-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3WMNGG3JlMRAkCt0wAQjrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_9e3fec68-5c61-403b-a06e-14585ea0066a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Outlaws | Bar & Grill",
      "poi_type": "Entertainment",
      "poi_address": "120 Main St S, Watford City, ND 58854, USA",
      "poi_short_description": "Down-to-earth eatery and bar with a casual setup offering beefy entrees, wine and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-5416-7518-8a0a-5812c3b895e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-5416-7518-8a0a-5812c3b895e5",
        "storage_key": "property/6767906449167237/01a03ece-5416-7518-8a0a-5812c3b895e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.outlawsbarngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6918243379283263072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outlaws--bar--grill",
      "poi_latitude": "47.801951",
      "poi_longitude": "-103.282645",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-842-6859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi36JKGy3JlMRYH7g87KJAmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6970b809-0774-462c-be4f-2f027d7ee08b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "The Watford",
      "poi_type": "Restaurants",
      "poi_address": "810 3rd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "Modern rooms & suites with free breakfast & WiFi, plus a lounge bar, guest laundry & meeting spaces.",
      "poi_long_description": "Modern rooms & suites with free breakfast & WiFi, plus a lounge bar, guest laundry & meeting spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1363-750b-8404-f90a94b05602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1363-750b-8404-f90a94b05602",
        "storage_key": "property/6767906449167237/01a03ed0-1363-750b-8404-f90a94b05602.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewatford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7602303376690638740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-watford",
      "poi_latitude": "47.7978238",
      "poi_longitude": "-103.296182",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-5b46-70f8-85a6-8e83019a5d3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed0-5b46-70f8-85a6-8e83019a5d3b",
        "storage_key": "property/6767906449167237/01a03ed0-5b46-70f8-85a6-8e83019a5d3b.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ8c0Gm0K3JlMRlO9lcqTOgGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_a2375548-a618-4a0d-bf60-70818f7bc5ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Little Missouri Grille",
      "poi_type": "Restaurants",
      "poi_address": "601 2nd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "Breakfast and lunch options and prime rib served at this casual steakhouse.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-39ef-716a-b0ff-f84ce69df379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-39ef-716a-b0ff-f84ce69df379",
        "storage_key": "property/6767906449167237/01a03ece-39ef-716a-b0ff-f84ce69df379.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/littlemissourigrille/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1070437223064732235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-missouri-grille",
      "poi_latitude": "47.7984666",
      "poi_longitude": "-103.2916733",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-444-6315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiawt5g_cJlMRSwIho_v02g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_262e2193-af9e-4e4d-9c10-cb657b6eeb4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Tomate Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "722 Main St N #1, Watford City, ND 58854, USA",
      "poi_short_description": "Casual eatery serving Mexican dishes such as burritos, asada fries, and birria tacos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-9734-75cb-b43d-567eb160644f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-9734-75cb-b43d-567eb160644f",
        "storage_key": "property/6767906449167237/019d0227-9734-75cb-b43d-567eb160644f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tomatemexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6598265940725761118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomate-mexican-grill",
      "poi_latitude": "47.8093364",
      "poi_longitude": "-103.282806",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 310-351-8273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAAEO3JlMRXoSE-um_kVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_5d3e64e6-9562-4031-abfe-f4510a4be00d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "My Little Mexico",
      "poi_type": "Restaurants",
      "poi_address": "2008 Main St, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-4105-7058-93b9-31fa3216fd54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-4105-7058-93b9-31fa3216fd54",
        "storage_key": "property/6767906449167237/01a03ece-4105-7058-93b9-31fa3216fd54.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://mylittlemexicond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349268385350225908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-little-mexico",
      "poi_latitude": "47.7800909",
      "poi_longitude": "-103.282164",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-713-0602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40yuo8m5JlMR9A_bRiZHmiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_119f59c9-c074-4696-82f6-277bdb212c17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Godfather's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "107 8th St SE, Watford City, ND 58854, USA",
      "poi_short_description": "Chain eatery specializing in thick-crust pizzas, also offering sides & desserts.",
      "poi_long_description": "Chain eatery specializing in thick-crust pizzas, also offering sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1170-758b-b4f0-d5620b432739.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1170-758b-b4f0-d5620b432739",
        "storage_key": "property/6767906449167237/01a03ed0-1170-758b-b4f0-d5620b432739.webp",
        "width": 380,
        "height": 265
      },
      "poi_business_url": "http://godfathers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7475355556538546216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "godfathers-pizza",
      "poi_latitude": "47.792957",
      "poi_longitude": "-103.2819181",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-3704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw_ID2Xa3JlMRKPg4xUXMvWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3ec13d81-bf9e-47ea-9778-38158608e878",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Twist Mexican Food Restaurants Watford City North Dakota",
      "poi_type": "Restaurants",
      "poi_address": "404 2nd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "Casual restaurant serving Mexican fast food such as burritos and fajitas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-9aa9-76a9-9e74-b538ff74d20a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-9aa9-76a9-9e74-b538ff74d20a",
        "storage_key": "property/6767906449167237/019d0227-9aa9-76a9-9e74-b538ff74d20a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://twistmexicanfood.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3761435692558375204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twist-mexican-food-restaurants-watford-city-north-dakota",
      "poi_latitude": "47.799857",
      "poi_longitude": "-103.288235",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-842-3595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed1e-7248-b884-fd48f43f1f5d",
        "storage_key": "property/6767906449167237/019d0227-ed1e-7248-b884-fd48f43f1f5d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8B-omm3JlMRJNlqXNVNMzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_41cb1b65-c459-42f8-9e85-c1b8c912558e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Cash Wise Foods Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "113 6th Ave SE Ste 5100, Watford City, ND 58854, USA",
      "poi_short_description": "Grocery store featuring a bakery and a deli, plus a meat department and a floral shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-3d76-741d-9ec3-90d24f5285f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-3d76-741d-9ec3-90d24f5285f7",
        "storage_key": "property/6767906449167237/01a03ece-3d76-741d-9ec3-90d24f5285f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cashwise.com/CWstore3042?utm_source=local+listing&utm_medium=organic&utm_campaign=grocery&utm_id=watford+city",
      "poi_directions_map_url": "https://maps.google.com/?cid=5570636791790078655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cash-wise-foods-grocery-store",
      "poi_latitude": "47.7941894",
      "poi_longitude": "-103.2794864",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-842-2519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed22-7476-a969-46180494f798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed22-7476-a969-46180494f798",
        "storage_key": "property/6767906449167237/019d0227-ed22-7476-a969-46180494f798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzYeT_mW3JlMRv4pey6XgTk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1b7e3bf4-6128-4437-a062-ab4367829bdc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Jack & Jill",
      "poi_type": "Shopping & Retail",
      "poi_address": "104 3rd Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "Locally owned food supplier carrying a variety of products, including meat and produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-39fe-7129-a70d-d16fa4c7fdba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-39fe-7129-a70d-d16fa4c7fdba",
        "storage_key": "property/6767906449167237/01a03ece-39fe-7129-a70d-d16fa4c7fdba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.watfordjackandjill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408155457606251847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack--jill",
      "poi_latitude": "47.8034581",
      "poi_longitude": "-103.2820829",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-842-2369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed22-7476-a969-46180494f798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed22-7476-a969-46180494f798",
        "storage_key": "property/6767906449167237/019d0227-ed22-7476-a969-46180494f798.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57zMuW23JlMRR_UBXnR6teM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c4a6e12e-59ec-46ec-a2d8-9e1c149b8c6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Barrett Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "145 Main St N, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ab1e-76bf-b001-e1842a80d4e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-ab1e-76bf-b001-e1842a80d4e5",
        "storage_key": "property/6767906449167237/019d0227-ab1e-76bf-b001-e1842a80d4e5.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://stores.healthmart.com/barrettpharmacy/stores.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1146043248553507804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrett-pharmacy",
      "poi_latitude": "47.8021694",
      "poi_longitude": "-103.2833614",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-842-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f0a7-713b-9180-b2637b072914.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f0a7-713b-9180-b2637b072914",
        "storage_key": "property/6767906449167237/019d0227-f0a7-713b-9180-b2637b072914.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozj7N2y3JlMR3DtEN0OQ5w8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_70a26a31-3c6c-41f3-906a-f2939e32d0b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Transportation & Transit",
      "poi_address": "124 Main St S, Watford City, ND 58854, USA",
      "poi_short_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_long_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1916-73b2-96aa-705ff592195a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1916-73b2-96aa-705ff592195a",
        "storage_key": "property/6767906449167237/01a03ed0-1916-73b2-96aa-705ff592195a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.maverik.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10031260613529277410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "47.7993508",
      "poi_longitude": "-103.2822157",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-401-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-5b49-7057-8c7f-2fc5f1db8853.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed0-5b49-7057-8c7f-2fc5f1db8853",
        "storage_key": "property/6767906449167237/01a03ed0-5b49-7057-8c7f-2fc5f1db8853.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn97c2G63JlMR4pPHTmEyNos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_645b4278-5c46-4175-80ca-3977b2f8efc7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Tractor Supply Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "105 6th Ave SE, Watford City, ND 58854, USA",
      "poi_short_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_long_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1793-716a-b877-eb5653fc3fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1793-716a-b877-eb5653fc3fbd",
        "storage_key": "property/6767906449167237/01a03ed0-1793-716a-b877-eb5653fc3fbd.webp",
        "width": 1200,
        "height": 901
      },
      "poi_business_url": "https://www.tractorsupply.com/tsc/store_Watfordcity-ND-58854_1812",
      "poi_directions_map_url": "https://maps.google.com/?cid=3242264978568644584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tractor-supply-co",
      "poi_latitude": "47.7953933",
      "poi_longitude": "-103.2803122",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-842-2521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f041-723b-b9b1-cdd0382584c0",
        "storage_key": "property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZyT60BK3JlMR6AdG29HW_iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_6fb1121c-5e08-4f60-9b1d-fa4a57446668",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "107 8th Ave SE, Watford City, ND 58854, USA",
      "poi_short_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_long_description": "Gas-station & convenience-store chain stocking snacks, hot foods, beverages & sundries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1c1c-76b5-8261-23247d84f11d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1c1c-76b5-8261-23247d84f11d",
        "storage_key": "property/6767906449167237/01a03ed0-1c1c-76b5-8261-23247d84f11d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/watford-city/107-8th-ave-se/2746435?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16434953800015698141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "47.7931608",
      "poi_longitude": "-103.282348",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f0a6-762b-a624-8d42c4d11510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f0a6-762b-a624-8d42c4d11510",
        "storage_key": "property/6767906449167237/019d0227-f0a6-762b-a624-8d42c4d11510.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJieZkvGa3JlMR3VjkrWevFOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_adedfb32-e74a-44b3-b1d6-c051e0faa5d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "One Stop",
      "poi_type": "Shopping & Retail",
      "poi_address": "US-85, Watford City, ND 58854, USA",
      "poi_short_description": "Mini-market chain, open every day for groceries, alcohol and newspapers; some have post offices.",
      "poi_long_description": "Mini-market chain, open every day for groceries, alcohol and newspapers; some have post offices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1945-7669-a3de-b161e0285a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1945-7669-a3de-b161e0285a3a",
        "storage_key": "property/6767906449167237/01a03ed0-1945-7669-a3de-b161e0285a3a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://onestop.umn.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17420260355361118512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-stop",
      "poi_latitude": "47.7985376",
      "poi_longitude": "-103.2924175",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-444-3122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f0a6-762b-a624-8d42c4d11510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f0a6-762b-a624-8d42c4d11510",
        "storage_key": "property/6767906449167237/019d0227-f0a6-762b-a624-8d42c4d11510.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJq-bt1G63JlMRMJkeKH8ywfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_4f23df1f-2d74-4d76-a3e1-14b647b4e4ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "406 Hunter's Run St, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-b09d-737a-b3f2-3f2f75c16b7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-b09d-737a-b3f2-3f2f75c16b7f",
        "storage_key": "property/6767906449167237/019d0227-b09d-737a-b3f2-3f2f75c16b7f.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nd/watford-city/25493",
      "poi_directions_map_url": "https://maps.google.com/?cid=14657862651880144547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "47.805057",
      "poi_longitude": "-103.226501",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-840-6524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f041-723b-b9b1-cdd0382584c0",
        "storage_key": "property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBTftoPG3JlMRo_7H02swa8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_9e4e4aea-20b6-4858-b1d4-a2c5c606ce94",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "609 Main St, Watford City, ND 58854, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1a8e-728c-af8c-851ba4efa6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1a8e-728c-af8c-851ba4efa6a5",
        "storage_key": "property/6767906449167237/01a03ed0-1a8e-728c-af8c-851ba4efa6a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/nd/watford-city/609-s-main-street?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10354488118191028733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "47.7944954",
      "poi_longitude": "-103.2843944",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-941-9965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f041-723b-b9b1-cdd0382584c0",
        "storage_key": "property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx-s0Dma3JlMR_XnHQxWIso8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_54edb628-0cdc-4b19-afe2-94b8d33b5043",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Runnings",
      "poi_type": "Shopping & Retail",
      "poi_address": "113 6th Ave SE Ste 5200, Watford City, ND 58854, USA",
      "poi_short_description": "Longtime chain retailer with a wide array of home & farm supplies & outdoor recreation equipment.",
      "poi_long_description": "Longtime chain retailer with a wide array of home & farm supplies & outdoor recreation equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-a8ac-77aa-a9a2-4a862446620b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-a8ac-77aa-a9a2-4a862446620b",
        "storage_key": "property/6767906449167237/019d0227-a8ac-77aa-a9a2-4a862446620b.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "https://www.runnings.com/storelocator/store/watford_city",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640899459903678850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "runnings",
      "poi_latitude": "47.79435669999999",
      "poi_longitude": "-103.2805298",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-842-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f041-723b-b9b1-cdd0382584c0",
        "storage_key": "property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJizz7NGS3JlMRgmkIWJPtCWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ff9afe62-529e-4eb8-83b0-d07cc2295f47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City High School",
      "poi_type": "Education",
      "poi_address": "2313 Wolves Den Parkway, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.watford-city.k12.nd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13873200751285731561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-high-school",
      "poi_latitude": "47.7999076",
      "poi_longitude": "-103.2421269",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-444-3624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrU4zDI63JlMR6YARdpSCh8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0cd5cdf6-42fc-4047-9b31-1620a4735cd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City Middle School",
      "poi_type": "Education",
      "poi_address": "100 3rd St NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1a08-759a-9af7-42b0903291e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1a08-759a-9af7-42b0903291e7",
        "storage_key": "property/6767906449167237/01a03ed0-1a08-759a-9af7-42b0903291e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.watford-city.k12.nd.us/schools/watford-middle",
      "poi_directions_map_url": "https://maps.google.com/?cid=10077431690199284957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-middle-school",
      "poi_latitude": "47.8017893",
      "poi_longitude": "-103.279143",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-444-3624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrUeHbm63JlMR3byXzro62os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8ec7b55f-8b78-40be-8093-eafcbf204a55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Badlands Elementary School",
      "poi_type": "Education",
      "poi_address": "300 3rd St SE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-323c-7313-8414-2e82afa92ccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-323c-7313-8414-2e82afa92ccf",
        "storage_key": "property/6767906449167237/01a03ed0-323c-7313-8414-2e82afa92ccf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10520446352317886632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "badlands-elementary-school",
      "poi_latitude": "47.7985012",
      "poi_longitude": "-103.2784823",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-444-2985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWS6km23JlMRqDB2vDciAJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_69515879-e8b8-4df9-81e3-f5f390d750af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Fox Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "2610 Wolves Den Pkwy, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.watford-city.k12.nd.us/schools/fox-hills/index",
      "poi_directions_map_url": "https://maps.google.com/?cid=11249324633892591317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-hills-elementary-school",
      "poi_latitude": "47.7987226",
      "poi_longitude": "-103.238006",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-444-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUX1weAG3JlMR1RY4LiehHZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ecfd5fd8-dc3a-4eb9-a0b8-ea4f2eb79bb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Rough Rider Center",
      "poi_type": "Entertainment",
      "poi_address": "2209 Wolves Den Pkwy, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1efb-75cc-9cc2-245dd8c7a127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1efb-75cc-9cc2-245dd8c7a127",
        "storage_key": "property/6767906449167237/01a03ed0-1efb-75cc-9cc2-245dd8c7a127.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "http://www.roughridercenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7977451214206392433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rough-rider-center",
      "poi_latitude": "47.7996205",
      "poi_longitude": "-103.2444863",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-842-3665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqqrHJlMRcdjH65yZtW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_f6121810-0c1a-414a-9fa9-5805f9be81ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "MCPSD#1 Transportation Facility",
      "poi_type": "Education",
      "poi_address": "908 4th Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1ee9-7789-882d-f90d9667bcc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1ee9-7789-882d-f90d9667bcc1",
        "storage_key": "property/6767906449167237/01a03ed0-1ee9-7789-882d-f90d9667bcc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15591613573199974201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcpsd1-transportation-facility",
      "poi_latitude": "47.8052113",
      "poi_longitude": "-103.268304",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-444-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkwyWWGm3JlMROU--2e-JYNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b73573ee-4706-400c-88f2-43c78ed738e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Wolf Pup Daycare",
      "poi_type": "Education",
      "poi_address": "325 3rd St SE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1d38-7713-a6df-b1b684ea9ff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1d38-7713-a6df-b1b684ea9ff1",
        "storage_key": "property/6767906449167237/01a03ed0-1d38-7713-a6df-b1b684ea9ff1.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "http://www.wolfpupdaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5632654209170971411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wolf-pup-daycare",
      "poi_latitude": "47.7983533",
      "poi_longitude": "-103.280161",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdRkSoG-3JlMRE5s-ACk1K04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3cdf9d10-ba7c-4e56-8ed6-f27a61d8f65e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Catuli Academy",
      "poi_type": "Education",
      "poi_address": "908 14th St SW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1d14-76b4-9b76-21b6200f537c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1d14-76b4-9b76-21b6200f537c",
        "storage_key": "property/6767906449167237/01a03ed0-1d14-76b4-9b76-21b6200f537c.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "http://www.catuliacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1744449116106889765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "catuli-academy",
      "poi_latitude": "47.7918196",
      "poi_longitude": "-103.3038306",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-570-7667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg22Icwi3JlMRJZpLhjqHNRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_03127804-f109-4df9-85b0-0b1cd488589e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Wolf Pup Learning Center",
      "poi_type": "Education",
      "poi_address": "212 2nd St NW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3907238943187162816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wolf-pup-learning-center",
      "poi_latitude": "47.8029174",
      "poi_longitude": "-103.2813397",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqxgRQSy3JlMRwFY-DR5NOTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_9493c00d-b97d-4749-b501-01ead6cbddbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Six Shooters",
      "poi_type": "Entertainment",
      "poi_address": "120 Main St S, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-1e36-7317-8f03-0dee13967653.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-1e36-7317-8f03-0dee13967653",
        "storage_key": "property/6767906449167237/01a03ed0-1e36-7317-8f03-0dee13967653.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sixshootersnd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6792988263455824608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-shooters",
      "poi_latitude": "47.8019446",
      "poi_longitude": "-103.2829687",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-842-6683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-5b52-731f-ab71-4a4cd7aed58f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed0-5b52-731f-ab71-4a4cd7aed58f",
        "storage_key": "property/6767906449167237/01a03ed0-5b52-731f-ab71-4a4cd7aed58f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJozj7N2y3JlMR4JquttWKRV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_000d11dd-1c92-458c-aa6e-90f502d52d59",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "McKenzie County Heritage Park & North Dakota Oil Museum",
      "poi_type": "Entertainment",
      "poi_address": "904 2nd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-6ba2-71ea-83dd-b3f96e7883d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-6ba2-71ea-83dd-b3f96e7883d3",
        "storage_key": "property/6767906449167237/01a03ece-6ba2-71ea-83dd-b3f96e7883d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1460908655707426460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-county-heritage-park--north-dakota-oil-museum",
      "poi_latitude": "47.79900170000001",
      "poi_longitude": "-103.2968008",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-6434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f441-719a-af4f-e07fe8c53102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f441-719a-af4f-e07fe8c53102",
        "storage_key": "property/6767906449167237/019d0227-f441-719a-af4f-e07fe8c53102.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJadmbJGy3JlMRnA68oK4wRhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a3130920-469b-4ad1-8701-47714ea53351",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "The Merc at Long X Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "100 2nd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2697-7716-923c-a52f31578396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2697-7716-923c-a52f31578396",
        "storage_key": "property/6767906449167237/01a03ed0-2697-7716-923c-a52f31578396.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://longxmerc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8636638211766390175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-merc-at-long-x-visitor-center",
      "poi_latitude": "47.799798",
      "poi_longitude": "-103.2834797",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6ORq263JlMRn43m2bGA23c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_c979437c-8d5d-4f77-8896-2a528415c503",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Lewis & Clark Trail Museum",
      "poi_type": "Entertainment",
      "poi_address": "102 Indiana Ave, Alexander, ND 58831, USA",
      "poi_short_description": "Museum housing artifacts and exhibits related to local history, with free entry.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2305-7548-8ab2-94919fe75f9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2305-7548-8ab2-94919fe75f9a",
        "storage_key": "property/6767906449167237/01a03ed0-2305-7548-8ab2-94919fe75f9a.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.lewisandclarktrailmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2391424351265814080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis--clark-trail-museum",
      "poi_latitude": "47.8455818",
      "poi_longitude": "-103.6416222",
      "poi_miles_from_property": "21.4",
      "poi_walking_minutes": "7 hours 52 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 701-828-3595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f441-719a-af4f-e07fe8c53102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f441-719a-af4f-e07fe8c53102",
        "storage_key": "property/6767906449167237/019d0227-f441-719a-af4f-e07fe8c53102.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27-ao2yqJlMRQPZq9MYLMCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4d461f60-6abf-4cfa-9738-ee2af03c9d47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Wild West Water Park",
      "poi_type": "Entertainment",
      "poi_address": "125 3rd St SE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-6169-746e-a584-dba816aada19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-6169-746e-a584-dba816aada19",
        "storage_key": "property/6767906449167237/01a03ece-6169-746e-a584-dba816aada19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.watfordcityparks.com/Outdoor-Pool",
      "poi_directions_map_url": "https://maps.google.com/?cid=1020074741097448124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wild-west-water-park",
      "poi_latitude": "47.7996359",
      "poi_longitude": "-103.279858",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-444-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZ86rW-3JlMRvEJ2i5IIKA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_fae56801-bdc0-415a-81c6-d91cfd3794fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City Children's Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "120 Main St S, Watford City, ND 58854, USA",
      "poi_short_description": "Park with a children's playground and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-239b-71b8-872d-166da2471ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-239b-71b8-872d-166da2471ec6",
        "storage_key": "property/6767906449167237/01a03ed0-239b-71b8-872d-166da2471ec6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5124341047212027982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-childrens-park",
      "poi_latitude": "47.7999284",
      "poi_longitude": "-103.2827546",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f85a-7776-82da-832c96076d29",
        "storage_key": "property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQQB6m63JlMRTrAGUwhRHUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59849cc0-5bd6-4598-a4d0-f25e02af2af5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "North Unit Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "208 Scenic Dr, Watford City, ND 58854, USA",
      "poi_short_description": "Small national park dotted with bison, known for its steep trails and scenic drives. Friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2495-70fc-8dcd-796b827a3280.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2495-70fc-8dcd-796b827a3280",
        "storage_key": "property/6767906449167237/01a03ed0-2495-70fc-8dcd-796b827a3280.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/thro/learn/news/north-unit-visitor-center.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15336794621450826674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-unit-visitor-center",
      "poi_latitude": "47.5996968",
      "poi_longitude": "-103.2598252",
      "poi_miles_from_property": "17.3",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 701-623-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAy2ZIEWWJlMRsrOyTHM919Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_eeddc9ab-89c4-400f-9213-211877e97ca8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City Eagles Club - FOE #3543",
      "poi_type": "Restaurants",
      "poi_address": "1904 Main St, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-256a-7378-a204-65379c58dfd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-256a-7378-a204-65379c58dfd3",
        "storage_key": "property/6767906449167237/01a03ed0-256a-7378-a204-65379c58dfd3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/watfordcityeagles?mibextid=LQQJ4d",
      "poi_directions_map_url": "https://maps.google.com/?cid=17492608590288562100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-eagles-club---foe-3543",
      "poi_latitude": "47.7814512",
      "poi_longitude": "-103.2814946",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-842-3340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YwwNp4cbIcRtKcYQ9U6wvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_16c167f5-6a3f-4413-8f68-b8a8b0ee3599",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Outsider's Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "905 3rd Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "Relaxed bar offering an array of beer, cocktails, and pub eats, plus a jukebox.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2443-701c-a7a4-66fee9088525.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2443-701c-a7a4-66fee9088525",
        "storage_key": "property/6767906449167237/01a03ed0-2443-701c-a7a4-66fee9088525.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.facebook.com/outsidersbarandgrill",
      "poi_directions_map_url": "https://maps.google.com/?cid=17041545211876113475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outsiders-bar--grill",
      "poi_latitude": "47.796454",
      "poi_longitude": "-103.295137",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-2693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-ed20-76cb-8cd2-fdf3c87021c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-ed20-76cb-8cd2-fdf3c87021c5",
        "storage_key": "property/6767906449167237/019d0227-ed20-76cb-8cd2-fdf3c87021c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYeqMQkO3JlMRQ3yiiRS7f-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_217b19df-043b-4a6c-b7e7-f91e344847b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "McKenzie Health",
      "poi_type": "Health and Wellness",
      "poi_address": "709 4th Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-b69b-77ac-abbd-8ead00868ebe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-b69b-77ac-abbd-8ead00868ebe",
        "storage_key": "property/6767906449167237/019d0227-b69b-77ac-abbd-8ead00868ebe.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "http://www.mckenziehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3081500573302989170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-health",
      "poi_latitude": "47.8038773",
      "poi_longitude": "-103.2710472",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-842-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f0b3-71af-ab99-dff891ca2e77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f0b3-71af-ab99-dff891ca2e77",
        "storage_key": "property/6767906449167237/019d0227-f0b3-71af-ab99-dff891ca2e77.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXbntBK3JlMRciHj5nGwwyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_072848a8-183e-468e-9cff-ad9dd8c47e9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Connie Wold Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "200 8th St NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-275a-719f-ad8c-cc29d77eb1a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-275a-719f-ad8c-cc29d77eb1a1",
        "storage_key": "property/6767906449167237/01a03ed0-275a-719f-ad8c-cc29d77eb1a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://conniewoldwellnesscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2315484271673156064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "connie-wold-wellness-center",
      "poi_latitude": "47.8022176",
      "poi_longitude": "-103.2695901",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-842-6307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3abwkna3JlMR4CEVWK1AIiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_8c2c97af-2f56-40e3-84a6-4e153772ed62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "102 4th Ave SE, Watford City, ND 58854, USA",
      "poi_short_description": "Chain gym with 24-hour access offering one-on-one training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-d168-719b-a0c4-36e209c4af22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-d168-719b-a0c4-36e209c4af22",
        "storage_key": "property/6767906449167237/019d0227-d168-719b-a0c4-36e209c4af22.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/watford-city-north-dakota-5043/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=5043",
      "poi_directions_map_url": "https://maps.google.com/?cid=14450962043180941098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "47.7982537",
      "poi_longitude": "-103.2825811",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-842-4317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2E1-hS3JlMRKv9z7mkhjMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ad9a6a0b-56aa-4192-8dff-80b451eeb792",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Larsen Service Drug, Inc.",
      "poi_type": "Health and Wellness",
      "poi_address": "244 Main St N, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2ace-730b-a9d5-640ebc3422c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2ace-730b-a9d5-640ebc3422c3",
        "storage_key": "property/6767906449167237/01a03ed0-2ace-730b-a9d5-640ebc3422c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://larsenservicedrug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10612455300921125614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larsen-service-drug-inc",
      "poi_latitude": "47.8031556",
      "poi_longitude": "-103.282932",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-444-2410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f0a7-713b-9180-b2637b072914.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f0a7-713b-9180-b2637b072914",
        "storage_key": "property/6767906449167237/019d0227-f0a7-713b-9180-b2637b072914.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0RcSGy3JlMR7moddt4DR5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9cc31ac8-90fd-400e-b243-3efd071f2348",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Urban Body Works",
      "poi_type": "Health and Wellness",
      "poi_address": "309 12th St SE Ste C, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2bf7-775e-bb53-5e1752085eed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2bf7-775e-bb53-5e1752085eed",
        "storage_key": "property/6767906449167237/01a03ed0-2bf7-775e-bb53-5e1752085eed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8618655459806451223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-body-works",
      "poi_latitude": "47.8001643",
      "poi_longitude": "-103.2627162",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-590-4173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTdzXQWm3JlMRF5Y-I3qdm3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_61ccba1e-b610-4e5c-a3aa-3475bdb8485d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Garden of Healing",
      "poi_type": "Health and Wellness",
      "poi_address": "809 7th Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2c1a-7329-b9f5-9c3207df4bd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2c1a-7329-b9f5-9c3207df4bd4",
        "storage_key": "property/6767906449167237/01a03ed0-2c1a-7329-b9f5-9c3207df4bd4.webp",
        "width": 1280,
        "height": 574
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2380634053479367499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-of-healing",
      "poi_latitude": "47.7940853",
      "poi_longitude": "-103.2964078",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-842-4722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadmbJGy3JlMRSwPW-Q62CSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_a052b07b-4fdd-4522-8e1a-13551d01a42d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Elevated Therapeutic Massage & Bodyworks, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "113 6th Ave SE Ste 5400, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2c26-719b-bb84-2ac2d83276b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2c26-719b-bb84-2ac2d83276b8",
        "storage_key": "property/6767906449167237/01a03ed0-2c26-719b-bb84-2ac2d83276b8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://dakotabackandneck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17660164740712500081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elevated-therapeutic-massage--bodyworks-llc",
      "poi_latitude": "47.7943953",
      "poi_longitude": "-103.2795132",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYJCbUu3JlMRcQsMnUOCFfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_0fb1d263-8a6d-4a98-b2d7-daa7e74e6aac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Bolken Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 2nd Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-2d49-76a8-b3d6-0148995e19b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-2d49-76a8-b3d6-0148995e19b3",
        "storage_key": "property/6767906449167237/01a03ed0-2d49-76a8-b3d6-0148995e19b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://watfordcityparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3272936056270387134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bolken-park",
      "poi_latitude": "47.7992321",
      "poi_longitude": "-103.2730648",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f85a-7776-82da-832c96076d29",
        "storage_key": "property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3fzY7XC3JlMRvneQngDOay0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b44858e6-14ef-43ba-96fa-804b4aec8aae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "McKenzie County Athletic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2429 24th Ave SW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-e11e-753b-875d-a835d92f4bf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-e11e-753b-875d-a835d92f4bf9",
        "storage_key": "property/6767906449167237/019d0227-e11e-753b-875d-a835d92f4bf9.webp",
        "width": 447,
        "height": 336
      },
      "poi_business_url": "https://www.watfordcityparks.com/Parks/McKenzie-County-Athletic-Park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8296390187667154410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-county-athletic-park",
      "poi_latitude": "47.7752682",
      "poi_longitude": "-103.3209361",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-842-3665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f85a-7776-82da-832c96076d29",
        "storage_key": "property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_avTwPW7JlMR6uXvZeuyInM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_23896227-f3d5-4e7f-abfd-63779b9c0254",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Veterans Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "109 Park Ave E, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-30c1-76f7-ba41-23c2256c58e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-30c1-76f7-ba41-23c2256c58e3",
        "storage_key": "property/6767906449167237/01a03ed0-30c1-76f7-ba41-23c2256c58e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937158899663851891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veterans-memorial-park",
      "poi_latitude": "47.80121519999999",
      "poi_longitude": "-103.2818918",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f85a-7776-82da-832c96076d29",
        "storage_key": "property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xS9iW63JlMRc1EH-OByS88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71b0d8ce-0e98-4c25-b4de-f910d4fe0217",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Doc Nelson Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1505-1305 W Pheasant Ridge St, Watford City, ND 58854, USA",
      "poi_short_description": "Well-rated park, which is fenced in, featuring 3 separate areas for dogs of different sizes to run and play.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-ae69-7533-85cf-2f1fe08bce71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-ae69-7533-85cf-2f1fe08bce71",
        "storage_key": "property/6767906449167237/01a03ece-ae69-7533-85cf-2f1fe08bce71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18432598512383726823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doc-nelson-dog-park",
      "poi_latitude": "47.8173603",
      "poi_longitude": "-103.2785657",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f85a-7776-82da-832c96076d29",
        "storage_key": "property/6767906449167237/019d0227-f85a-7776-82da-832c96076d29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXarRigW3JlMR55QG2q--zf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_3eccc3c1-7e19-467a-b7dd-90d47ad71eed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Fox Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Watford City, ND 58854, USA",
      "poi_short_description": "Rolling golf course featuring 18 holes, a restaurant, and a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-9bfb-7085-90b4-2cdc05742db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-9bfb-7085-90b4-2cdc05742db9",
        "storage_key": "property/6767906449167237/01a03ece-9bfb-7085-90b4-2cdc05742db9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.foxhillsgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3837515665875925060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-hills-golf-course",
      "poi_latitude": "47.8051033",
      "poi_longitude": "-103.2331695",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-842-2074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f75b-741d-add7-828f3bde8afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f75b-741d-add7-828f3bde8afb",
        "storage_key": "property/6767906449167237/019d0227-f75b-741d-add7-828f3bde8afb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39_e9eu3JlMRRPiHhCqYQTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7d1093a0-0cc4-43f1-85b3-60c927b7af44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 12th Street Southeast, Box 730, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ece-a4f5-711b-8a89-30b74a7124e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ece-a4f5-711b-8a89-30b74a7124e6",
        "storage_key": "property/6767906449167237/01a03ece-a4f5-711b-8a89-30b74a7124e6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.wcairport.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14473169807114615700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-municipal-airport",
      "poi_latitude": "47.8033065",
      "poi_longitude": "-103.2600784",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-570-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f861-7124-85e4-1044a264827d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f861-7124-85e4-1044a264827d",
        "storage_key": "property/6767906449167237/019d0227-f861-7124-85e4-1044a264827d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWzQ5PYS3JlMRlLv55kEH28g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8ff23a9d-5a50-4e33-be42-96ff6bb0d407",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Williston Basin International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "14127 Jensen Ln, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-3183-70f7-b7f0-2bb0d1940869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-3183-70f7-b7f0-2bb0d1940869",
        "storage_key": "property/6767906449167237/01a03ed0-3183-70f7-b7f0-2bb0d1940869.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flywilliston.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7027633441429145880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-basin-international-airport",
      "poi_latitude": "48.2578206",
      "poi_longitude": "-103.7417095",
      "poi_miles_from_property": "49.8",
      "poi_walking_minutes": "18 hours 5 mins",
      "poi_biking_minutes": "4 hours 27 mins",
      "poi_driving_minutes": "59 mins",
      "poi_business_phone": "+1 701-875-8594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f861-7124-85e4-1044a264827d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f861-7124-85e4-1044a264827d",
        "storage_key": "property/6767906449167237/019d0227-f861-7124-85e4-1044a264827d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4mULFpnIVMRGEkKiGErh2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a4da4032-a2b1-485c-a109-2e5f51f20f4c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "The Corner Post",
      "poi_type": "Transportation & Transit",
      "poi_address": "3408 4th Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "Truck stop offering a gas station, convenience store, and car wash, as well as good food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-35d3-760b-a493-919d4f23ec4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-35d3-760b-a493-919d4f23ec4a",
        "storage_key": "property/6767906449167237/01a03ed0-35d3-760b-a493-919d4f23ec4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cornerpostnd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5379306977330787095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-corner-post",
      "poi_latitude": "47.8051471",
      "poi_longitude": "-103.2255024",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-444-2971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f041-723b-b9b1-cdd0382584c0",
        "storage_key": "property/6767906449167237/019d0227-f041-723b-b9b1-cdd0382584c0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8TioROW3JlMRF_OU8TEjp0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_19fb960f-39ea-4500-8eb2-d8ba3494d8c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "McKenzie County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 5th St NW #524, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-355f-72ee-82b7-651965d9ae65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-355f-72ee-82b7-651965d9ae65",
        "storage_key": "property/6767906449167237/01a03ed0-355f-72ee-82b7-651965d9ae65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mckenziecountynd.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13790455837795605084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-county-courthouse",
      "poi_latitude": "47.8022304",
      "poi_longitude": "-103.2891258",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-444-3616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f820-7301-a504-8feda131c496",
        "storage_key": "property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVf6SWq3JlMRXNqE_oSKYb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_c14713e5-25d1-47c4-bbcc-2bc9c3dddf8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Watford City City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "213 2nd St NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-35da-719a-8fe2-dd25a7b1ce5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-35da-719a-8fe2-dd25a7b1ce5b",
        "storage_key": "property/6767906449167237/01a03ed0-35da-719a-8fe2-dd25a7b1ce5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwatfordcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10170185557186526948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watford-city-city-hall",
      "poi_latitude": "47.8029972",
      "poi_longitude": "-103.281922",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-2533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f820-7301-a504-8feda131c496",
        "storage_key": "property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVdjf0223JlMR5D7pW-HBI40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_b3147566-cd73-4653-bf44-a3d1301719b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "McKenzie County Sheriff's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 12th St SE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mckenziesheriff.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14034950186855929935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-county-sheriffs-office",
      "poi_latitude": "47.7886393",
      "poi_longitude": "-103.2633315",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-444-3654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-5b5a-7743-a861-2457aa334697.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed0-5b5a-7743-a861-2457aa334697",
        "storage_key": "property/6767906449167237/01a03ed0-5b5a-7743-a861-2457aa334697.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJJznUDmu3JlMRT5jZp9UoxsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_9bfae182-8437-46a6-845e-9cd042c7da1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "MCPSD#1 District Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 3rd St NE, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.watford-city.k12.nd.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16979313681054801531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcpsd1-district-offices",
      "poi_latitude": "47.8020226",
      "poi_longitude": "-103.2797764",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f3ab-76db-93e5-6b860f777b31",
        "storage_key": "property/6767906449167237/019d0227-f3ab-76db-93e5-6b860f777b31.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYwC2z0-3JlMRe54zKdWjous",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c7d85bd-d207-4491-a3da-b3b0aecaac74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1204 4th Ave NE, Watford City, ND 58854, USA",
      "poi_short_description": "Chain location offering its usual services such as mail delivery, shipping, and money orders.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-323d-770a-89c0-832accabd9b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-323d-770a-89c0-832accabd9b0",
        "storage_key": "property/6767906449167237/01a03ed0-323d-770a-89c0-832accabd9b0.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1386630?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5881111431495844410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "47.8055408",
      "poi_longitude": "-103.2615857",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-5b51-753e-b896-c19401b4affc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03ed0-5b51-753e-b896-c19401b4affc",
        "storage_key": "property/6767906449167237/01a03ed0-5b51-753e-b896-c19401b4affc.webp",
        "width": 192,
        "height": 157
      },
      "poi_google_place_id": "ChIJPWOuyG23JlMROoLM_q_nnVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_aa212182-dfa3-455b-8daf-8a01851234c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Upper Missouri District Health- UMDHU",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 5th St NW, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-d421-764a-96c6-77ee7a7dfd1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0227-d421-764a-96c6-77ee7a7dfd1d",
        "storage_key": "property/6767906449167237/019d0227-d421-764a-96c6-77ee7a7dfd1d.webp",
        "width": 1280,
        "height": 966
      },
      "poi_business_url": "http://www.umdhu.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14775065918715696796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-missouri-district-health--umdhu",
      "poi_latitude": "47.8024084",
      "poi_longitude": "-103.2895348",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-3449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f820-7301-a504-8feda131c496",
        "storage_key": "property/6767906449167237/019d0227-f820-7301-a504-8feda131c496.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyzzKWq3JlMRnJYH4iuUC80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_1eec4717-beb5-4c37-b561-5f29dba46e32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "custom",
      "poi_name": "Mountrail McKenzie Human Service Zone | Watford City Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 5th St NW Ste 790, Watford City, ND 58854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/01a03ed0-47f6-7601-ba43-5fcda51826fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03ed0-47f6-7601-ba43-5fcda51826fe",
        "storage_key": "property/6767906449167237/01a03ed0-47f6-7601-ba43-5fcda51826fe.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://county.mckenziecounty.net/Department/SocialServices",
      "poi_directions_map_url": "https://maps.google.com/?cid=484047119710093596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountrail-mckenzie-human-service-zone--watford-city-office",
      "poi_latitude": "47.80371479999999",
      "poi_longitude": "-103.2887438",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-444-3661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0227-f42d-77e9-bbcc-163dd1066313",
        "storage_key": "property/6767906449167237/019d0227-f42d-77e9-bbcc-163dd1066313.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJznUDmu3JlMRHAHfcEqutwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ab4a90a6f9963076ea1eadcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2feef7cab43a68e092714e92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2618034a49e417750fd63876",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5c092e7ae3b3f09c2ef8a6a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_eae3c479ca00775db09764b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4e8caac3db74fef8f4683bf4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "rating": "5",
      "name": "Mackenzie Fuller",
      "text": "The apartments are spacious, well taken care of, and a great place to live. Maintenance requests are taken care of very quickly. Salli is the best property manager we have ever lived under. Any time we had questions or concerns, she was always very happy to help! She truly cares about her residents and it shows!",
      "date": "2024-07-11",
      "title": "false"
    },
    {
      "id": "ec_b6c9d0bf33700de27d11f85f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "rating": "5",
      "name": "Bitcoinor Fucyu",
      "text": "Had a great exp renting here over the last couple of years. It was quiet and friendly.  Also, I need to mention Sally! She works in the leasing office and was always friendly to work with and great at communication, even when it was -55°F. 😅\n\nI would happily recommend them to any family or friends if they needed a place to stay while on rotation in ND.",
      "date": "2025-03-12",
      "title": "false"
    },
    {
      "id": "ec_adbfae7c5e338018547b087b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "rating": "5",
      "name": "Charlyn S Churape",
      "text": "We are amazed with our New apartment!! I love how spacious the living room is and the closets are decent sizes... Sallie was really helpful with everything that we needed to know & help us move really fast.. So yes I would gladly recommend 👌 Pheasant Ridge Apartments.",
      "date": "2023-04-05",
      "title": "false"
    },
    {
      "id": "ec_8678f6e441fd1e676b99ec91",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "rating": "5",
      "name": "Adam Skiles",
      "text": "My new apartment has an amazing layout and a super large living room & Kitchen!  So much room to cook & entertain!!  The staff was very helpful and accommodated my schedule to view the apartment.  They went over my lease with me instead of leaving it to me to read the fine print.  My experience was terrific. 5 stars!!",
      "date": "2021-02-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2aa25641358c51d0a7b9ef87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019ddcfc-6cd0-73fb-a219-d97c7984e5f9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-6cd0-73fb-a219-d97c7984e5f9",
        "storage_key": "property/6767906449167237/019ddcfc-6cd0-73fb-a219-d97c7984e5f9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 B",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JmaBxrigQjg"
    },
    {
      "id": "ec_9d184dec6111de13f59ab0f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019ddcfc-6d08-76ff-8601-704a5e38d7be.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-6d08-76ff-8601-704a5e38d7be",
        "storage_key": "property/6767906449167237/019ddcfc-6d08-76ff-8601-704a5e38d7be.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x2 A",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PfNd361EEJG"
    },
    {
      "id": "ec_73c6021949a781105350d0a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167237/019ddcfc-6d77-7456-a208-1259a5296725.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfc-6d77-7456-a208-1259a5296725",
        "storage_key": "property/6767906449167237/019ddcfc-6d77-7456-a208-1259a5296725.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3x2 B",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Hb4SisnG4Lt"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0b0d0-8016-77eb-ba86-6e2609b5fdef",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Pheasant Ridge Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-watford-city",
      "search_query": "in-unit laundry apartments Watford City",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Watford City",
      "h2_subtitle": "Discover in-unit laundry apartments in vibrant Watford City. Enjoy comfort and convenience at Pheasant Ridge.",
      "page_copy": "Experience the convenience of in-unit laundry apartments in Watford City at Pheasant Ridge. Our community offers spacious one-, two-, and three-bedroom layouts designed to suit your lifestyle. With the added bonus of having laundry facilities right in your apartment, chores become a breeze, giving you more time to enjoy everything Watford City has to offer.\n\nAt Pheasant Ridge, comfort is key. Our apartments come with essential features such as central air and heat, ensuring you stay comfortable year-round. Select units also boast vaulted ceilings, adding a touch of elegance to your home. Take advantage of the patio to relax, or use our online resident services for easy management of your living experience. Join our community where convenience meets comfort in Watford City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Watford City",
      "seo_description": "Find in-unit laundry apartments at Pheasant Ridge, Watford City with spacious beds and essential comfort features. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-mckenzie-county",
      "search_query": "pet friendly apartments in McKenzie County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in McKenzie County",
      "h2_subtitle": "Explore pet-friendly apartments in McKenzie County's serene setting. Pheasant Ridge welcomes you and your furry friends.",
      "page_copy": "For those searching for pet-friendly apartments in McKenzie County, Pheasant Ridge offers the perfect home. Our community embraces both you and your furry companions, providing a welcoming environment where all residents feel at ease. Choose from one-, two-, or three-bedroom layouts featuring in-home laundry and central air, making life with pets easy and comfortable.\n\nPheasant Ridge is more than just pet-friendly; it’s a community designed for convenience and relaxation. Enjoy features like patios for you and your pet to unwind, and take advantage of our online resident services for effortless living. With select apartments offering vaulted ceilings, there's plenty of room for you and your pets to roam. Make McKenzie County your home with Pheasant Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in McKenzie County",
      "seo_description": "Discover pet-friendly apartments at Pheasant Ridge in McKenzie County. Spacious layouts and pet amenities await you!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-with-central-air-watford-city-nd",
      "search_query": "apartments with central air Watford City ND",
      "category": "Amenity",
      "h1_title": "Apartments with Central Air in Watford City, ND",
      "h2_subtitle": "Discover the comfort of central air in Watford City, ND. Pheasant Ridge offers apartments designed for modern living.",
      "page_copy": "Stay comfortable year-round in our apartments with central air in Watford City, ND at Pheasant Ridge. Our community offers a range of one-, two-, and three-bedroom layouts that ensure you and your family enjoy a climate-controlled home. Experience modern living with features such as in-home laundry and more.\n\nAt Pheasant Ridge, our priority is your comfort. Apart from central air, our apartments include amenities like patios and online resident services to enhance your lifestyle. For added luxury, select units boast vaulted ceilings offering a sense of spaciousness. Come and visit today to see why Pheasant Ridge is the perfect place to call home in Watford City, ND.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Central Air in Watford City, ND",
      "seo_description": "Find comfortable apartments with central air at Pheasant Ridge, Watford City, ND. Choose from modern one-, two-, and three-bedroom layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "watford-city-apartments-with-dishwasher",
      "search_query": "Watford City apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Watford City Apartments with Dishwasher",
      "h2_subtitle": "Enjoy the ease of apartments with a dishwasher in Watford City. Pheasant Ridge offers modern living spaces for your comfort.",
      "page_copy": "Find your ideal home at Pheasant Ridge, where Watford City apartments feature convenient amenities like a dishwasher. Our spacious one-, two-, and three-bedroom apartments are designed for modern living, offering features that make everyday life easier and more comfortable.\n\nLiving at Pheasant Ridge means you'll enjoy not only the convenience of in-home dishwashers but also other essential features such as central air and in-home laundry. Our community enhances your lifestyle with amenities like patios and online resident services. Select units offer vaulted ceilings, giving your home an open, airy atmosphere. Discover the luxury and ease of apartment living in Watford City at Pheasant Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Watford City Apartments with Dishwasher",
      "seo_description": "Find modern Watford City apartments with a dishwasher at Pheasant Ridge. Enjoy spacious living with essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-with-balcony-north-dakota",
      "search_query": "apartments with balcony North Dakota",
      "category": "Amenity",
      "h1_title": "Apartments with Balcony in North Dakota",
      "h2_subtitle": "Discover relaxing apartments with balconies in North Dakota. Enjoy the views and fresh air at Pheasant Ridge.",
      "page_copy": "Experience the charm of North Dakota living at Pheasant Ridge, where our apartments offer spacious balconies perfect for relaxation. Choose from our one-, two-, or three-bedroom layouts, each featuring essential amenities like in-home laundry and central air, complemented by your own private outdoor space to unwind.\n\nAt Pheasant Ridge, every apartment is a retreat. Our community provides you with more than just balconies; enjoy convenient online resident services and vaulted ceilings in select units that enhance your living experience. Whether you're savoring morning coffee outdoors or taking in the sunset, Pheasant Ridge offers the perfect setting in North Dakota.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Balcony in North Dakota",
      "seo_description": "Find serene apartments with balconies in North Dakota at Pheasant Ridge. Enjoy private outdoor spaces and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-in-watford-city",
      "search_query": "one bedroom apartments in Watford City",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Watford City",
      "h2_subtitle": "Explore our one-bedroom apartments in Watford City. Pheasant Ridge offers comfort and convenience tailored to your lifestyle.",
      "page_copy": "Welcome to Pheasant Ridge, where comfortable one-bedroom apartments await you in Watford City. Our thoughtfully designed apartments include everyday essentials like in-home laundry and central air, creating a cozy haven that matches your lifestyle. Step into a home that suits your needs with an inviting layout and all the modern conveniences you desire.\n\nLiving at Pheasant Ridge is enhanced by amenities beyond the apartment, such as online resident services and the option of vaulted ceilings that add spaciousness. Delight in the simplicity and efficiency of our one-bedroom apartments, which provide the perfect balance of style and function. Make Pheasant Ridge your next home and experience Watford City living at its finest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Watford City",
      "seo_description": "Find cozy one-bedroom apartments in Watford City at Pheasant Ridge. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-north-dakota-area",
      "search_query": "two bedroom apartments North Dakota Area",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in North Dakota Area",
      "h2_subtitle": "Spacious two-bedroom apartments in the North Dakota Area at Pheasant Ridge. Discover comfort and modern amenities today.",
      "page_copy": "Discover the perfect two-bedroom apartment in the North Dakota Area at Pheasant Ridge. Our welcoming community offers spacious floor plans with features like in-home laundry and central air, providing the comfort and convenience you desire. Whether you're sharing the space or enjoying the extra room, our two-bedroom apartments are ideal for any lifestyle.\n\nPheasant Ridge enhances your living experience with amenities such as patios and online resident services, ensuring a seamless living experience. Select homes boast vaulted ceilings, adding an elegant touch to your living space. Embrace the tranquility and modern conveniences of two-bedroom living in the North Dakota Area at Pheasant Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in North Dakota Area",
      "seo_description": "Explore roomy two-bedroom apartments in North Dakota Area at Pheasant Ridge. Enjoy modern comforts and extensive amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "three-bedroom-rentals-mckenzie-county",
      "search_query": "three bedroom rentals McKenzie County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals in McKenzie County",
      "h2_subtitle": "Discover spacious three-bedroom rentals in McKenzie County at Pheasant Ridge. Enjoy comfort and modern features in Watford City.",
      "page_copy": "Experience superior living in McKenzie County with our three-bedroom rentals at Pheasant Ridge. Designed for comfort and practicality, these spacious apartments feature central air, in-home laundry, and a variety of layouts to fit your needs. Perfect for families or roommates, our three-bedroom units offer a welcoming environment for any lifestyle.\n\nPheasant Ridge ensures that you have everything you need right at home. Relax on your patio or take advantage of online resident services for added convenience. Vaulted ceilings available in select units enhance the sense of space and light. Come home to Pheasant Ridge and experience the best of three-bedroom living in Watford City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals in McKenzie County",
      "seo_description": "Find ideal three-bedroom rentals in McKenzie County at Pheasant Ridge. Spacious designs and modern amenities await in Watford City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-near-watford-city-high-school-nd",
      "search_query": "apartments near watford city high school nd",
      "category": "School",
      "h1_title": "Apartments Near Watford City High School ND",
      "h2_subtitle": "Find convenient apartments near Watford City High School ND at Pheasant Ridge. Ideal for families and students alike.",
      "page_copy": "For those seeking proximity to education, Pheasant Ridge offers apartments near Watford City High School ND that blend comfort and convenience. Situated in a prime location, our community provides easy access for students and families who value short commutes and accessibility.\n\nAt Pheasant Ridge, you’ll find spacious one-, two-, and three-bedroom apartments featuring essential amenities like in-home laundry and central air. Enjoy modern comforts with the added benefit of being near educational facilities, making it the perfect choice for families prioritizing school proximity. Experience the ease of living at Pheasant Ridge, where school and home are just a step away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Watford City High School ND",
      "seo_description": "Live close to Watford City High School ND at Pheasant Ridge. Explore our comfortable and accessible apartment options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "watford-city-middle-school-nearby-apartments",
      "search_query": "watford city middle school nearby apartments",
      "category": "School",
      "h1_title": "Watford City Middle School Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to Watford City Middle School at Pheasant Ridge. Perfect for families and students.",
      "page_copy": "Pheasant Ridge offers convenient housing options with its nearby apartments to Watford City Middle School. This prime location ensures families have easy access to education, making the daily commute worry-free. Choose from our range of well-designed one-, two-, and three-bedroom units, each offering central air and in-home laundry for enhanced comfort.\n\nOur community is tailored for modern living with amenities that include a patio and online resident services. Select apartments even feature elegant vaulted ceilings. At Pheasant Ridge, enjoy a blend of comfort and convenience, with the added benefit of being close to Watford City Middle School, ensuring an ideal family-friendly environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Watford City Middle School Nearby Apartments",
      "seo_description": "Discover Pheasant Ridge apartments close to Watford City Middle School. Explore our family-friendly community today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-close-to-badlands-elementary-school-mckenzie-county",
      "search_query": "apartments close to badlands elementary school mckenzie county",
      "category": "School",
      "h1_title": "Apartments Close to Badlands Elementary School",
      "h2_subtitle": "Find family-friendly apartments close to Badlands Elementary School in McKenzie County. Perfect for young families and educators.",
      "page_copy": "Located in McKenzie County, Pheasant Ridge offers apartments close to Badlands Elementary School, providing an ideal option for families seeking proximity and convenience. Our community features one-, two-, and three-bedroom apartments designed with your needs in mind, including central air, in-home laundry, and other essential amenities.\n\nEnjoy the benefits of living in a community that understands the importance of location and comfort. With a short commute to Badlands Elementary School, parents can appreciate the ease of transporting children to and from their academic activities. Choose Pheasant Ridge and enhance your lifestyle with accessible, modern living spaces and a supportive environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Badlands Elementary McKenzie County",
      "seo_description": "Find convenient family-friendly living at Pheasant Ridge, close to Badlands Elementary School in McKenzie County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "fox-hills-elementary-apartments-in-watford-city",
      "search_query": "fox hills elementary apartments in watford city",
      "category": "School",
      "h1_title": "Fox Hills Elementary Apartments in Watford City",
      "h2_subtitle": "Discover Pheasant Ridge, offering apartments in Watford City near Fox Hills Elementary. Perfect for families seeking an ideal location.",
      "page_copy": "If you're searching for apartments in Watford City near Fox Hills Elementary, Pheasant Ridge is the community to explore. Our welcoming environment features spacious one-, two-, and three-bedroom units, thoughtfully designed with amenities like in-home laundry and central air to ensure day-to-day comfort.\n\nLocated conveniently, Pheasant Ridge allows families easy access to Fox Hills Elementary, making school commutes a breeze. Enjoy a relaxed lifestyle with additional perks like online resident services and select units with vaulted ceilings. Embrace modern living at Pheasant Ridge and experience the blend of convenience and community-focused design in Watford City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Hills Elementary Apartments Watford City",
      "seo_description": "Explore Pheasant Ridge apartments in Watford City, ideally located near Fox Hills Elementary. Perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-near-mckenzie-health-watford-city",
      "search_query": "apartments near McKenzie Health Watford City",
      "category": "Hospital",
      "h1_title": "Apartments Near McKenzie Health Watford City",
      "h2_subtitle": "Find conveniently located apartments near McKenzie Health in Watford City. Perfect for healthcare professionals and families.",
      "page_copy": "At Pheasant Ridge, you can find thoughtfully designed apartments strategically located near McKenzie Health in Watford City. Our community offers an inviting selection of one-, two-, and three-bedroom units, each equipped with modern essentials such as in-home laundry and central air, providing a comfortable lifestyle close to healthcare facilities.\n\nLiving near McKenzie Health means easy access for healthcare professionals and families needing regular visits. Our community promotes convenience and well-being, with added amenities like a patio and online resident services. Choose Pheasant Ridge for its prime location and commitment to enhancing your residential experience in Watford City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McKenzie Health Watford City",
      "seo_description": "Discover apartments at Pheasant Ridge, close to McKenzie Health in Watford City. Ideal for healthcare professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "apartments-near-watford-city-children's-park-nd",
      "search_query": "apartments near Watford City Children's Park ND",
      "category": "Park",
      "h1_title": "Apartments Near Watford City Children's Park",
      "h2_subtitle": "Explore family-friendly apartments near Watford City Children's Park, ND. Ideal for those seeking recreation and comfort.",
      "page_copy": "Pheasant Ridge offers apartments in Watford City conveniently situated near Children's Park, ND. Our community provides spacious one-, two-, and three-bedroom options equipped with essentials like in-home laundry and central climate control, allowing for a comfortable and modern lifestyle.\n\nProximity to Watford City Children's Park means families can enjoy easy access to outdoor activities and recreational spaces. At Pheasant Ridge, additional amenities such as online resident services and select units with vaulted ceilings enhance your living experience. Experience the best of accessible recreation and home comfort by choosing our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Watford City Children's Park",
      "seo_description": "Pheasant Ridge offers family-friendly apartments near Watford City Children's Park, ND. Enjoy comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "pheasant-ridge-proximity-bolken-park",
      "search_query": "Pheasant Ridge proximity Bolken Park",
      "category": "Park",
      "h1_title": "Pheasant Ridge Nearby Bolken Park",
      "h2_subtitle": "Discover Pheasant Ridge, located close to Bolken Park. Enjoy convenient, park-side living in Watford City.",
      "page_copy": "Pheasant Ridge is ideally positioned near Bolken Park, offering a picturesque setting for those seeking outdoor enjoyment in Watford City. With our selection of one-, two-, and three-bedroom apartments, residents can enjoy the convenience of nearby green spaces while benefiting from the essentials provided in every home, such as in-home laundry and central air conditioning.\n\nLiving near Bolken Park means outdoor adventures are just around the corner, perfect for those who appreciate nature and leisure activities. Pheasant Ridge enhances this proximity with additional amenities, including online resident services and the option of vaulted ceilings in select units. Embrace a lifestyle that seamlessly blends natural beauty and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pheasant Ridge Near Bolken Park",
      "seo_description": "Enjoy park-side living at Pheasant Ridge, close to Bolken Park in Watford City. Discover comfort and convenience today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "living-close-to-mckenzie-county-athletic-park",
      "search_query": "living close to McKenzie County Athletic Park",
      "category": "Park",
      "h1_title": "Living Close to McKenzie County Athletic Park",
      "h2_subtitle": "Experience the convenience of living close to McKenzie County Athletic Park. Perfect for sports enthusiasts and active lifestyles.",
      "page_copy": "Experience the thrill of living close to McKenzie County Athletic Park at Pheasant Ridge. Our community offers one-, two-, and three-bedroom apartments in Watford City, designed for those who enjoy an active lifestyle. Enjoy everyday comforts like in-home laundry and central air, paired with the convenience of a location near this vibrant athletic hub.\n\nLiving near McKenzie County Athletic Park means you can easily participate in sports, fitness activities, and community events. At Pheasant Ridge, you'll find additional perks such as online resident services and relaxing patios, making it an ideal choice for those who value both convenience and comfort in their living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to McKenzie County Athletic Park",
      "seo_description": "Choose Pheasant Ridge for its proximity to McKenzie County Athletic Park. Ideal for active living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "homes-near-veterans-memorial-park-watford-city",
      "search_query": "homes near Veterans Memorial Park Watford City",
      "category": "Park",
      "h1_title": "Homes Near Veterans Memorial Park",
      "h2_subtitle": "Explore homes near Veterans Memorial Park in Watford City. Perfectly positioned for leisure and relaxation.",
      "page_copy": "Find your new home at Pheasant Ridge, located conveniently near Veterans Memorial Park in Watford City, ND. Our community offers a range of spacious one-, two-, and three-bedroom apartment homes featuring modern comforts like in-home laundry and central air. This prime location provides easy access to Veterans Memorial Park, ideal for those who enjoy peaceful strolls and community gatherings.\n\nEnjoy the blend of serene park-side living and contemporary amenities at Pheasant Ridge. With features such as online resident services, available vaulted ceilings, and comfortable carpeting, our community is designed to meet the needs of modern families and individuals. Embrace a life of ease with nature and city life at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Veterans Memorial Park Watford City",
      "seo_description": "Discover comfortable living at Pheasant Ridge, near Veterans Memorial Park in Watford City. Enjoy park-side homes with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167237",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-by-doc-nelson-dog-park",
      "search_query": "dog-friendly apartments by Doc Nelson Dog Park",
      "category": "Park",
      "h1_title": "Dog-Friendly Apartments Near Doc Nelson Dog Park",
      "h2_subtitle": "Find dog-friendly apartments by Doc Nelson Dog Park. Ideal living spaces for pet owners in Watford City.",
      "page_copy": "Welcome to Pheasant Ridge, where dog-friendly living is right by Doc Nelson Dog Park. Our one-, two-, and three-bedroom apartments cater to pet owners who want convenient access to open spaces. Imagine daily walks and playful afternoons just steps from your home in Watford City.\n\nAt Pheasant Ridge, you and your furry friends can enjoy comfortable living with features like central air, in-home laundry, and spacious patios. This prime location not only offers pets the joy of nearby Doc Nelson Dog Park but also provides residents with amenities such as online services and select vaulted ceiling apartments. Enjoy the perfect balance of nature and modern comforts here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
      "featured_image_media": {
        "alt_text": "A virtual staging of a modern living room with a sectional sofa, coffee table, and large sliding glass door.",
        "public_id": "019d0227-3d26-758b-9a5a-c7ed7c412ef3",
        "storage_key": "property/6767906449167237/019d0227-3d26-758b-9a5a-c7ed7c412ef3.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Doc Nelson Dog Park",
      "seo_description": "Pheasant Ridge offers pet-friendly apartments by Doc Nelson Dog Park. Enjoy comfort and convenience for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309808893"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125709"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5NPPRBF8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "ffe93196-ebec-40cf-9c62-8e475c52e379"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a2bba5c4-3e1d-417a-a75d-d1f9cd330142/app.js?property=a2bba5c4-3e1d-417a-a75d-d1f9cd330142&propertyName=Pheasant+Ridge&channelUuid=c2490f07-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47759046523"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkZkOUFUUFU4NXErYlBiemwvRWJQdVE9PSIsInZhbHVlIjoiOFZiN1pCTDM0Q1BQV1FMNSs1d2w1dz09IiwibWFjIjoiNTJlYjI2NmI2OTBlNjNmYTBkODliYjg0OTk4NWI3Mzc2YTU1MWZhMzBkOTQwNDYxNzBkZDk2MWZhMjdkYTc2ZiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309808893",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7017125709",
  "custom_google_gtm_id": "GTM-5NPPRBF8",
  "custom_rollout_phase": "Phase 7.3",
  "custom_rentgrata_token": "ffe93196-ebec-40cf-9c62-8e475c52e379",
  "custom_vibesites_theme": "Homestead",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a2bba5c4-3e1d-417a-a75d-d1f9cd330142/app.js?property=a2bba5c4-3e1d-417a-a75d-d1f9cd330142&propertyName=Pheasant+Ridge&channelUuid=c2490f07-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47759046523",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkZkOUFUUFU4NXErYlBiemwvRWJQdVE9PSIsInZhbHVlIjoiOFZiN1pCTDM0Q1BQV1FMNSs1d2w1dz09IiwibWFjIjoiNTJlYjI2NmI2OTBlNjNmYTBkODliYjg0OTk4NWI3Mzc2YTU1MWZhMzBkOTQwNDYxNzBkZDk2MWZhMjdkYTc2ZiJ9",
  "custom_audioeye_site_id": "ccd4a25d-b508-4f12-801d-a17aa8f20d62",
  "custom_audioeye_site_hash": "6f8a7c72ef356b268acfa3db25e950aa"
};

export const generatedAt = '2026-10-29T23:13:37.233Z';
